/**
 * ONE INVOICE: its lines, what has landed against it, and the three things the office does with it.
 *
 * Send it, which stamps the issue date and works out the due date from the published terms, and since
 * ops #76 O6 emails the one who pays her link once its PDF is made, the answer saying what went. Void
 * it, which the server refuses once money has landed. Record a payment against it, which is the
 * one place in the money screens where a dollar figure is typed, and that figure is money that
 * ARRIVED, never a price: the lines on the invoice came from the visit, which came from the
 * agreement, which came from the published card, and nothing on this screen can change them.
 *
 * A REFUND IS RECORDED HERE TOO, and it is almost always against a PAID invoice with nothing owed,
 * because a full refund is the published remedy for a promise we broke. So the money form is drawn
 * while money is owed and again once the invoice is paid, opening on "refund" in the second case.
 * The server's own sentences do the refusing: a payment is a positive amount, a refund a negative.
 *
 * "Send her a link" makes a signed, expiring link to this invoice for one contact of the household.
 * The token exists once, in the answer to that request, and this screen shows it as text to copy
 * and keeps it nowhere. It is not a client login (CLAUDE.md binding rule 5): it opens her invoice
 * and the ways to pay it, and the one thing behind it that is not a read is her ask for a Stripe
 * page to pay this one invoice through.
 *
 * AT HOME (`CLIENT_PAGES_AT_HOME`, `docs/plan-clients-only-home.md` concern B1d, D8), where the server
 * names her invoice page at home and the household's live doors there (`atHome`), a client never
 * reaches an ops address, so neither "Send the invoice" nor "Send her a link" makes a link of ours.
 * Each shows her invoice page at home to a person who holds a `client` door there, `invited` or
 * `granted`, and otherwise says why not (`herPageAtHome`): a person with no door, or a `member`, whom
 * home shows no money, is invited from the household screen, home's own invitation email; a person
 * with no email address on file cannot sign in at home until texted codes exist, so the office adds
 * her address or calls her. With the switch empty the server names nothing at home and both screens
 * are as they were.
 *
 * "Send the invoice" (ops #46) is that link sent to her in words she reads, on an invoice money is
 * owed on. It makes her link for the person chosen and puts it in front of the office in words the
 * office edits and approves: what is owed, Zelle named first with the tag decoded from the one
 * stored code and the invoice's memo, its number or the day of the visit, then her link. The server
 * records the message and the
 * phone system delivers a text, home an email (ops #76 O6), so nothing is sent from here (binding
 * rule 3). An email goes only past ops's own switch for client email (`me.emailGoLive`), and where it
 * would not go to her address the form says where the switch stands and offers the send disabled,
 * naming it (`EmailGate`), as it does for a text. Her page offers Zelle,
 * then her bank account, then a card, and asks Stripe for a page only when she presses for one, so
 * this asks Stripe nothing and needs no key; where there is none (`me.payLinks`) the card says her
 * page offers Zelle and the office's number. It goes by email alone until an owner allows pay links
 * by text (ops #21, `me.payLinksByText`), and the form says so. A text goes only past ops's own
 * go-live switch too (ops #31, `me.smsGoLive`): the channel follows her to email where the switch
 * would hold a text to her number, and a text chosen anyway says where the switch stands, names it,
 * and is offered disabled (`TextingGate`). For an invoice the household's saved
 * method pays (step 3b), the words say her method is charged once she tells us the clean went well,
 * and the card says so; for one it does not pay, the card says why not, from the invoice's own charge
 * (`whyNotCharged`): issued before she saved it, or a charge that was declined, waited on her bank,
 * did not go through, was stopped, or went through before money was handed back.
 *
 * THE WORDS ASK "HOW DID WE DO?" (ops #46, step 2), and "How did we do?" on this screen is where that
 * question stands: who it went to, whether it arrived, when the reminder and the call from the office
 * fall due, every answer she gave from her link or on the phone, and a hold, which stops everything
 * further on the invoice until a person releases it. The office holds, releases and records the
 * answer she rang with here; an answer below happy opens an issue and a follow-up on the server.
 *
 * THE AUTOMATIC CHARGE (ops #46, step 4b) sits beside that question on an invoice the household's
 * saved method pays: where it stands, what opened or holds it, what Stripe was asked for and when,
 * and the office's doors while no try has claimed it, "Charge her saved card now" on a charge that is
 * not her first and "Do not charge this one", and "Lift the pause" once she has said she is paying by
 * Zelle (the owner, 2026-09-23). A charge that did not go through raises a follow-up that opens this
 * screen, and the office sends her the invoice from here.
 *
 * WHILE A BANK PAYMENT THROUGH STRIPE CLEARS ON IT (the review of the staging walk of 2026-09-23) the
 * screen says how much and since when, sends no invoice, and asks before money is typed against it:
 * the office ticks that it is separate money, and the request says so, which the server requires, since
 * once the bank payment lands the same money could otherwise have been taken twice. Since ops #54 it
 * offers no void, which the server refuses too, and a hold and her answer say what they stop and that
 * the bank payment on its way is not among it.
 *
 * NOBODY BUT AN OWNER STARTS ON "TYPED IN BY AN OWNER" (ops #54, item 4): the money form starts an owner
 * on it, and the rest of the office on no word, asking which is true, from every word a person may type.
 *
 * THE STAGING WALK OF 2026-09-23 found three things this screen now does: it reads the invoice again once
 * the words are handed on, so the question says where it stands; it says a bank payment through
 * Stripe is on its way and since when; and where nothing is owed it offers no hold and none of the
 * charge's doors, and never sends the office to a page of every way to pay. Its walk of the automatic
 * charge found three more: the charge says what the next run decides the moment her answer or her
 * pause is recorded, "Do not charge this one" asks once more before it ends the charge, and the
 * question before a lift says a held question or an open issue still holds it.
 *
 * ITS DOCUMENTS (ops #76 O3): the invoice's PDF, its cancellation and the receipt of each payment
 * applied to it, each made once on the server after the press that wrote it. "Documents" says where
 * each stands, opens one made through a ten-minute link minted at the press, says one waits for the
 * address in Settings, and offers "Try again" on one given up.
 *
 * HER REPORT THROUGH HOME THAT SHE SENT IT BY ZELLE (ops #71 item 5): while it stands, one line beside
 * the money saying what she said and that nothing is paid until the office records it, and "Clear the
 * Zelle report", asked once more, for a Zelle that is not coming; once cleared, who cleared it and
 * when. While it stands "Lift the pause" is withheld, with a line saying to clear her report first:
 * the clear and the lift are two decisions, and the server refuses the lift all the same.
 *
 * ITS EMAILS (ops #76 O6, `docs/plan-o6-o9-emails.md` section 3.7): every email about it and about money
 * that landed on it, newest first, each with where it stands in the words every email is said in
 * (`components/EmailRows.tsx`), and beside each payment that landed, "Receipt emailed" once ops's
 * receipt email for it is on its way or gone. Nothing to press: home delivers, ops records.
 *
 * Every read here asks for a recent sign-in, and the 403 is answered with the server's link.
 */
import { useCallback, useEffect, useRef, useState, type FormEvent } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  FEEDBACK_FACES,
  OPT_OUT_LINE,
  PAYMENT_KINDS,
  PAYMENT_METHODS,
  SIGN_IN_LINE,
  TYPED_ENTRY_SOURCES,
  VISIT_KIND_LABELS,
  ZELLE,
  ZELLE_PAUSE_BUSINESS_DAYS,
  heldByEmailSwitch,
  invoiceMemo,
  type DocumentKind,
  type FeedbackFace,
  type PaymentKind,
  type PaymentMethod,
  type TypedEntrySource,
} from '@fk/shared';
import {
  ApiError,
  answerSurvey,
  cancelCharge,
  clearZelleReport,
  createGrant,
  getClient,
  getInvoice,
  holdSurvey,
  invoiceDocumentLink,
  liftChargePause,
  listInvoiceDocuments,
  needsStepUp,
  recordPayment,
  releaseCharge,
  releaseSurvey,
  retryInvoiceDocument,
  revokeGrant,
  sendInvoice,
  sendPayLink,
  voidInvoice,
  type ChargeAfterClear,
  type ChargeNextRun,
  type ContactRow,
  type EmailGoLive,
  type FeedbackBody,
  type GrantMade,
  type GrantRow,
  type InvoiceAnswer,
  type InvoiceAtHome,
  type InvoiceAutopay,
  type InvoiceCharge,
  type InvoiceDetail as InvoiceDetailShape,
  type InvoiceDocument,
  type InvoiceEmailAnswer,
  type InvoiceRow,
  type InvoiceSurvey,
  type InvoiceZelleReport,
  type Me,
  type SmsGoLive,
  type WhenCharged,
} from '../api.ts';
import { choiceLineOf, choiceSentOf, choiceWords } from '../choices.ts';
import { Card, Detail, Pill, READING_WIDTH, ScreenTitle } from '../components/AppShell.tsx';
import { Button, SelectField, TextAreaField, TextField } from '../components/Field.tsx';
import { Busy, ErrorNotice, SavedNotice, StepUpNotice } from '../components/Notice.tsx';
import { EmailGate, emailPath } from '../components/EmailGate.tsx';
import { EmailRows } from '../components/EmailRows.tsx';
import { TextingGate, textingPath } from '../components/TextingGate.tsx';
import {
  businessHoursWords,
  centsFromDollars,
  dayOf,
  dollarsForInput,
  formatDay,
  formatInstant,
  isDay,
  money,
  orNull,
  savedMethodNoun,
  savedMethodWords,
} from '../format.ts';
import {
  CHARGE_CANCEL_REASON_LABELS,
  CHARGE_GATE_REASON_LABELS,
  CHARGE_HOLD_REASON_LABELS,
  ENTRY_SOURCE_LABELS,
  FEEDBACK_FACE_LABELS,
  FEEDBACK_SOURCE_LABELS,
  INVOICE_CHARGE_STATE_LABELS,
  INVOICE_STATE_LABELS,
  MESSAGE_CHANNEL_LABELS,
  PAYMENT_KIND_LABELS,
  PAYMENT_METHOD_LABELS,
  SURVEY_HOLD_REASON_LABELS,
  SURVEY_STATE_LABELS,
} from '../labels.ts';

const CAN_VOID = new Set(['draft', 'sent', 'overdue']);
/** Money still owed on the first three; a refund of money already landed on the last. */
const CAN_TAKE_MONEY = new Set(['sent', 'part_paid', 'overdue', 'paid']);
/** Money owed, so an invoice to send her: the three states the server sends one for. */
const PAY_BY_LINK = new Set(['sent', 'part_paid', 'overdue']);

export function InvoiceDetail({ me }: { me: Me }) {
  const { id = '' } = useParams();
  const [detail, setDetail] = useState<InvoiceDetailShape | null>(null);
  const [error, setError] = useState<ApiError | null>(null);
  const [attempt, setAttempt] = useState(0);
  const [said, setSaid] = useState<string | null>(null);

  const reload = useCallback(() => setAttempt((n) => n + 1), []);
  const done = (sentence: string) => {
    setSaid(sentence);
    reload();
  };

  useEffect(() => {
    let live = true;
    setError(null);
    getInvoice(id, `/invoices/${id}`)
      .then((answer) => {
        if (live) setDetail(answer);
      })
      .catch((thrown: unknown) => {
        if (!live) return;
        setError(
          thrown instanceof ApiError
            ? thrown
            : new ApiError(0, 'error', 'That invoice did not load.'),
        );
      });
    return () => {
      live = false;
    };
  }, [id, attempt]);

  const back = (
    <Link
      to="/money"
      className="mb-3 inline-flex min-h-11 desk:min-h-9 items-center text-sm font-medium text-navy/70"
    >
      Back to money
    </Link>
  );

  if (error) {
    return (
      <div>
        {back}
        {needsStepUp(error) ? (
          <StepUpNotice error={error} />
        ) : (
          <ErrorNotice title="That invoice did not load" message={error.message} onRetry={reload} />
        )}
      </div>
    );
  }

  if (!detail) {
    return (
      <div>
        {back}
        <Busy what="this invoice" />
      </div>
    );
  }

  const { invoice, lines, allocations, grants, balanceCents, survey, answers } = detail;
  /**
   * Money is still owed on it: the three states the server sends an invoice in, with a balance. What
   * matters only before payment, a hold on the question and the doors on the automatic charge, is
   * offered only while this holds (the staging walk of 2026-09-23).
   */
  const owed = PAY_BY_LINK.has(invoice.state) && balanceCents > 0;
  /** A bank payment through Stripe on its way on this invoice: since when, and how much. */
  const clearing = detail.bankPaymentClearing;
  /**
   * Her report through home that she sent it by Zelle (ops #71 item 5): drawn while it stands and
   * once the office has cleared it, and not at all where she made none or once nothing is owed.
   */
  const zelleReport = detail.zelleReport ?? null;
  const zelleReported = zelleReport?.stands === true;

  return (
    <div className={READING_WIDTH}>
      {back}
      {/* Titled by its number once it has one (ops #76 O2), the household beneath it; an invoice
          with none, a draft or one sent before numbering began, is titled by its household. */}
      <ScreenTitle
        title={invoice.number ? `Invoice ${invoice.number}` : invoice.clientName}
        subtitle={`${invoice.number ? `${invoice.clientName}: ` : ''}${VISIT_KIND_LABELS[invoice.visitKind]} on ${formatDay(invoice.visitDate)}`}
      />
      <div className="mb-4 flex flex-wrap gap-2">
        <Pill
          tone={invoice.state === 'paid' ? 'sage' : invoice.state === 'draft' ? 'gold' : 'quiet'}
        >
          {INVOICE_STATE_LABELS[invoice.state]}
        </Pill>
        {invoice.dueOn && invoice.dueOn < me.today && balanceCents > 0 ? (
          <Pill tone="coral">Late</Pill>
        ) : null}
      </div>

      {said ? (
        <div className="mb-4">
          <SavedNotice>{said}</SavedNotice>
        </div>
      ) : null}

      <Card className="mb-4">
        <h2 className="mb-2 font-serif text-lg">The lines</h2>
        {lines.length === 0 ? (
          <p className="text-sm text-coral">
            No lines. An invoice with nothing on it bills nothing.
          </p>
        ) : (
          <ul className="divide-y divide-navy/10">
            {lines.map((line) => (
              <li key={line.id} className="flex justify-between gap-3 py-2 text-sm">
                <span>
                  {line.description}
                  {line.quantity !== 1 ? (
                    <span className="text-navy/60">
                      {' '}
                      x{line.quantity} at {money(line.unitPriceCents)}
                    </span>
                  ) : null}
                </span>
                <span className="whitespace-nowrap">{money(line.amountCents)}</span>
              </li>
            ))}
          </ul>
        )}
        <div className="mt-3 flex justify-between border-t border-navy/20 pt-2 text-base">
          <span className="font-medium">Total</span>
          <span className="font-medium">{money(invoice.totalCents)}</span>
        </div>
        <div className="flex justify-between text-base">
          <span className={balanceCents > 0 ? 'font-semibold' : ''}>Still owed</span>
          <span className={balanceCents > 0 ? 'font-semibold' : ''}>{money(balanceCents)}</span>
        </div>
        {/* The walk of 2026-09-23: the screen said nothing while a bank payment cleared. Its review:
            the screen still sent the invoice and took a Zelle typed against it without a word. */}
        {clearing ? (
          <p className="mt-3 rounded-lg border border-gold/50 bg-gold/10 px-3 py-2 text-sm">
            {`A bank payment of ${money(clearing.amountCents)} for this invoice is on its way through Stripe, started ${formatInstant(clearing.since) ?? clearing.since}. It is recorded here once it clears, which takes a few business days. `}
            {CLEARING_HOLDS}
          </p>
        ) : null}
        <dl className="mt-3">
          <Detail label="Issued" value={formatDay(invoice.issuedOn)} />
          <Detail label="Due" value={formatDay(invoice.dueOn)} />
          <Detail label="Sent" value={formatInstant(invoice.sentAt)} />
          <Detail label="Paid" value={formatInstant(invoice.paidAt)} />
          <Detail label="Number" value={invoice.number} />
          <Detail label="Square invoice" value={invoice.squareInvoiceId} />
        </dl>
        <div className="mt-2 flex flex-wrap gap-3 text-sm">
          <Link
            to={`/clients/${invoice.clientId}`}
            className="inline-flex min-h-11 desk:min-h-9 items-center font-medium underline"
          >
            The household
          </Link>
          <Link
            to={`/visits/${invoice.visitId}`}
            className="inline-flex min-h-11 desk:min-h-9 items-center font-medium underline"
          >
            The visit
          </Link>
        </div>
      </Card>

      {/* A draft has no document; anything sent may (ops #76 O3). Read again with the invoice, so a
          receipt a payment just pressed shows the moment the money is recorded. */}
      {invoice.state !== 'draft' ? (
        <DocumentsPanel invoiceId={invoice.id} refresh={attempt} />
      ) : null}

      <Card className="mb-4">
        <h2 className="mb-2 font-serif text-lg">What has landed against it</h2>
        {allocations.length === 0 ? (
          <p className="text-sm text-navy/70">Nothing yet.</p>
        ) : (
          <ul className="divide-y divide-navy/10">
            {allocations.map((row) => (
              <li key={row.id} className="flex justify-between gap-3 py-2 text-sm">
                <span>
                  {/* Its receipt first, where it has one (ops #76 O2). */}
                  {row.receiptNumber ? `${row.receiptNumber}, ` : null}
                  {PAYMENT_METHOD_LABELS[row.method]}, {formatDay(row.receivedOn)}
                  {row.reference ? (
                    <span className="block text-xs text-navy/60">{row.reference}</span>
                  ) : null}
                  <span className="block text-xs text-navy/60">
                    {ENTRY_SOURCE_LABELS[row.entrySource]}
                  </span>
                  {/* Ops's receipt email for it, once it is on its way or gone (ops #76 O6). */}
                  {row.receiptEmailed ? (
                    <span className="block text-xs text-navy/60">Receipt emailed</span>
                  ) : null}
                </span>
                <span className="whitespace-nowrap">{money(row.amountCents)}</span>
              </li>
            ))}
          </ul>
        )}
      </Card>

      {/* Its emails and the money's (ops #76 O6), beside what landed. Absent from an older Worker. */}
      {detail.emails ? (
        <Card className="mb-4">
          <div data-emails>
            <h2 className="mb-2 font-serif text-lg">Emails</h2>
            {detail.emails.length === 0 ? (
              <p className="text-sm text-navy/70">No email about this invoice yet.</p>
            ) : (
              <EmailRows emails={detail.emails} />
            )}
          </div>
        </Card>
      ) : null}

      {invoice.state === 'draft' ? (
        <SendForm invoiceId={invoice.id} today={me.today} onDone={done} />
      ) : null}

      {/* Beside the money, since recording her Zelle when it comes is what marks it paid. */}
      {zelleReport !== null && (zelleReport.stands || zelleReport.clearedAt !== null) ? (
        <ZelleReportPanel
          invoiceId={invoice.id}
          report={zelleReport}
          balanceCents={balanceCents}
          chargeNext={chargeAfterClear(detail.charge, detail.autopay?.coversThisInvoice === true)}
          onDone={done}
        />
      ) : null}

      {CAN_TAKE_MONEY.has(invoice.state) && (balanceCents > 0 || invoice.state === 'paid') ? (
        <PaymentForm
          key={invoice.state}
          invoiceId={invoice.id}
          clientId={invoice.clientId}
          balanceCents={balanceCents}
          totalCents={invoice.totalCents}
          today={me.today}
          clearing={clearing}
          owner={me.role === 'owner'}
          onDone={done}
        />
      ) : null}

      {/* Keyed on the balance: money landing on the invoice changes what the words say is owed, so
          words written for the old balance go with it. Not while a bank payment clears: she has paid,
          and her page offers nothing to pay while it clears. */}
      {owed && clearing === null ? (
        <SendInvoicePanel
          key={`${invoice.state}-${balanceCents}`}
          invoice={invoice}
          balanceCents={balanceCents}
          canHandOff={me.canHandOffMessages}
          byText={me.payLinksByText}
          texting={me.smsGoLive ?? null}
          emailing={me.emailGoLive ?? null}
          stripeOn={me.payLinks}
          autopay={detail.autopay ?? null}
          charge={detail.charge ?? null}
          atHome={detail.atHome ?? null}
          onChanged={reload}
        />
      ) : null}

      {invoice.state !== 'draft' && invoice.state !== 'void' ? (
        <SurveyPanel
          invoiceId={invoice.id}
          survey={survey}
          answers={answers}
          owed={owed}
          clearing={clearing !== null}
          onDone={done}
        />
      ) : null}

      {detail.charge ? (
        <ChargePanel
          invoiceId={invoice.id}
          charge={detail.charge}
          balanceCents={balanceCents}
          owed={owed}
          stripeOn={me.payLinks}
          zelle={zelleOnRecord(detail.allocations)}
          zelleReported={zelleReported}
          onDone={done}
        />
      ) : null}

      {invoice.state !== 'draft' && invoice.state !== 'void' ? (
        <LinkPanel
          invoiceId={invoice.id}
          clientId={invoice.clientId}
          grants={grants}
          atHome={detail.atHome ?? null}
          onChanged={done}
        />
      ) : null}

      {/* Not while a bank payment clears (ops #54, item 3): her money would arrive for an invoice that
          bills nothing. The server refuses it too, and the sentence under the figures says why. */}
      {CAN_VOID.has(invoice.state) && clearing === null ? (
        <VoidButton invoiceId={invoice.id} onDone={done} />
      ) : null}
    </div>
  );
}

/* ------------------------------------------------------------------ *
 * Its documents (ops #76 O3).
 * ------------------------------------------------------------------ */

/**
 * WHAT THE OFFICE IS TOLD OF AN INVOICE'S PDFs, the one place these words are spelled. Office words,
 * never a client's: hers are `DOCUMENT_PAGE_WORDS` in `@fk/shared`. A document is named as its PDF is
 * titled, so the office and the file say one thing.
 */
export const DOCUMENT_OFFICE_WORDS = Object.freeze({
  heading: 'Documents',
  name: (kind: DocumentKind, number: string): string => {
    switch (kind) {
      case 'invoice':
        return `Invoice ${number}`;
      case 'cancellation':
        return `Invoice ${number}, cancelled`;
      case 'receipt':
        return `Receipt ${number}`;
      case 'refund':
        return `Refund ${number}`;
      case 'statement':
        return `Statement ${number}`;
    }
  },
  download: 'Download',
  getting: 'Getting the link',
  beingMade: 'Being made',
  waitingForAddress: 'Waiting for the address in Settings',
  failed: 'Could not be made',
  whatStopped: (failure: string): string => `What stopped it: ${failure}`,
  retry: 'Try again',
  retrying: 'Trying again',
  forgotten: 'Forgotten on request, so there is nothing to open',
  notLoaded: 'The documents did not load.',
});

/**
 * Where the screen sends the office once the link to a PDF is minted: this tab, to the one route for
 * files, which answers the PDF inline, and the back arrow returns here. One door, as her page's is, so
 * a test can stand at it; this same tab, so no pop-up blocker stands in the way of a link minted after
 * a wait.
 */
export const invoiceDocumentDoor = {
  go(url: string): void {
    window.open(url, '_self');
  },
};

/** The press in hand: a link or a retry asked for one document, or the server's refusal of it. */
type DocumentPress =
  | { readonly at: 'idle' }
  | { readonly at: 'getting' | 'retrying'; readonly documentId: string }
  | { readonly at: 'refused'; readonly documentId: string; readonly message: string };

/**
 * THE INVOICE'S PDFs: each named by its number, "Download" on one made, which mints a ten-minute link
 * for the person signed in at the press and opens it in this tab, "Being made" on one pending,
 * "Waiting for the address in Settings" on one held for it, which takes the office there, and "Could
 * not be made" with what stopped it and "Try again" on one given up, which puts it back to be made
 * after the answer and reads the list again. The note of what a render changed to print one is shown
 * under it. An invoice sent before the PDFs began has none, and nothing is drawn.
 */
function DocumentsPanel({ invoiceId, refresh }: { invoiceId: string; refresh: number }) {
  const [documents, setDocuments] = useState<readonly InvoiceDocument[] | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [press, setPress] = useState<DocumentPress>({ at: 'idle' });
  const [again, setAgain] = useState(0);
  const showing = useRef(true);

  useEffect(() => {
    showing.current = true;
    return () => {
      showing.current = false;
    };
  }, []);

  useEffect(() => {
    let live = true;
    listInvoiceDocuments(invoiceId, `/invoices/${invoiceId}`)
      .then((answer) => {
        if (!live) return;
        setDocuments(answer.documents);
        setLoadError(null);
      })
      .catch((thrown: unknown) => {
        if (!live) return;
        setLoadError(thrown instanceof ApiError ? thrown.message : DOCUMENT_OFFICE_WORDS.notLoaded);
      });
    return () => {
      live = false;
    };
  }, [invoiceId, refresh, again]);

  if (loadError !== null && documents === null) {
    return (
      <Card className="mb-4" label={DOCUMENT_OFFICE_WORDS.heading}>
        <h2 className="mb-2 font-serif text-lg">{DOCUMENT_OFFICE_WORDS.heading}</h2>
        <p className="text-sm text-coral" role="alert">
          {DOCUMENT_OFFICE_WORDS.notLoaded} {loadError}
        </p>
      </Card>
    );
  }
  if (documents === null || documents.length === 0) return null;

  async function open(documentId: string) {
    setPress({ at: 'getting', documentId });
    try {
      const link = await invoiceDocumentLink(invoiceId, documentId);
      if (!showing.current) return;
      setPress({ at: 'idle' });
      invoiceDocumentDoor.go(link.url);
    } catch (thrown) {
      if (!showing.current) return;
      setPress({ at: 'refused', documentId, message: refusalWords(thrown) });
    }
  }

  async function retry(documentId: string) {
    setPress({ at: 'retrying', documentId });
    try {
      await retryInvoiceDocument(invoiceId, documentId);
      if (!showing.current) return;
      setPress({ at: 'idle' });
      setAgain((n) => n + 1);
    } catch (thrown) {
      if (!showing.current) return;
      setPress({ at: 'refused', documentId, message: refusalWords(thrown) });
    }
  }

  const busy = press.at === 'getting' || press.at === 'retrying';

  return (
    <Card className="mb-4" label={DOCUMENT_OFFICE_WORDS.heading}>
      <h2 className="mb-2 font-serif text-lg">{DOCUMENT_OFFICE_WORDS.heading}</h2>
      <ul className="divide-y divide-navy/10">
        {documents.map((document) => {
          const pressed = press.at !== 'idle' && press.documentId === document.documentId;
          return (
            <li key={document.documentId} className="py-2 text-sm">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <span className="font-medium">
                  {DOCUMENT_OFFICE_WORDS.name(document.kind, document.number)}
                </span>
                <DocumentStands
                  document={document}
                  busy={busy}
                  pressed={pressed ? press.at : null}
                  onOpen={() => void open(document.documentId)}
                  onRetry={() => void retry(document.documentId)}
                />
              </div>
              {document.failure ? (
                <p className="mt-1 text-xs text-navy/70">
                  {DOCUMENT_OFFICE_WORDS.whatStopped(document.failure)}
                </p>
              ) : null}
              {document.renderNote ? (
                <p className="mt-1 text-xs text-navy/70">{document.renderNote}</p>
              ) : null}
              {pressed && press.at === 'refused' ? (
                <p className="mt-1 text-sm text-coral" role="alert">
                  {press.message}
                </p>
              ) : null}
            </li>
          );
        })}
      </ul>
    </Card>
  );
}

/** The server's own sentence for a refusal, or the network's. */
function refusalWords(thrown: unknown): string {
  return thrown instanceof ApiError ? thrown.message : DOCUMENT_OFFICE_WORDS.notLoaded;
}

/** Where one document stands, and the one door it offers, if any. */
function DocumentStands({
  document,
  busy,
  pressed,
  onOpen,
  onRetry,
}: {
  document: InvoiceDocument;
  busy: boolean;
  pressed: DocumentPress['at'] | null;
  onOpen: () => void;
  onRetry: () => void;
}) {
  switch (document.state) {
    case 'rendered':
      return (
        <Button tone="quiet" disabled={busy} onClick={onOpen}>
          {pressed === 'getting' ? DOCUMENT_OFFICE_WORDS.getting : DOCUMENT_OFFICE_WORDS.download}
        </Button>
      );
    case 'pending':
      return document.waitingForAddress ? (
        <Link to="/settings" className="font-medium underline">
          {DOCUMENT_OFFICE_WORDS.waitingForAddress}
        </Link>
      ) : (
        <span className="text-navy/70">{DOCUMENT_OFFICE_WORDS.beingMade}</span>
      );
    case 'failed':
      return (
        <span className="flex flex-wrap items-center gap-3">
          <span className="text-coral">{DOCUMENT_OFFICE_WORDS.failed}</span>
          <Button tone="quiet" disabled={busy} onClick={onRetry}>
            {pressed === 'retrying' ? DOCUMENT_OFFICE_WORDS.retrying : DOCUMENT_OFFICE_WORDS.retry}
          </Button>
        </span>
      );
    case 'forgotten':
      return <span className="text-navy/70">{DOCUMENT_OFFICE_WORDS.forgotten}</span>;
  }
}

/* ------------------------------------------------------------------ *
 * Send it.
 * ------------------------------------------------------------------ */

/**
 * WHAT BECAME OF THE INVOICE EMAIL THE SEND COMPOSED (ops #76 O6), in the office's words after the
 * number and the due day: going once its PDF is made, or why nothing went and what to do instead, so
 * the office never assumes she has it. "Send the invoice" below, her link in words the office edits,
 * is the way on where none went.
 */
export function invoiceEmailSentence(email: InvoiceEmailAnswer): string {
  const to = email.to ?? 'this person';
  switch (email.outcome) {
    case 'waiting_for_pdf':
      return `The invoice email to ${to}, with their link and "How did we do?", goes once its PDF is made.`;
    case 'refused_by_consent':
      // What the register said, and never that she did not agree: a stop or a do-not-contact mark
      // refuses her as surely as no yes on record (concern 7's review of ops #76 O6). A Worker older
      // than the field says nothing of why, so the screen claims no reason.
      return email.refusal
        ? `No email went to ${to}. The register refused it: ${email.refusal}. Ring them, or send them the invoice below another way.`
        : `No email went to ${to}: the register refused it, and the record says why. Ring them, or send them the invoice below another way.`;
    case 'not_enabled':
      return `No email went to ${to}: client email is not on in ops for their address, and the record says so. Ring them, or send them the invoice below another way.`;
    case 'not_chosen':
      // Their own choice, or the office's hold (ops #76 phase 2), in its words.
      return email.choice
        ? `No email went to ${to}: ${choiceWords(email.choice)}${email.officeCalls ? ' With email and texts off for invoices, a task gives the office the call.' : ' Ring them, or send them the invoice below another way.'}`
        : `No email went to ${to}: their choices about messages hold it. Ring them, or send them the invoice below another way.`;
    case 'held':
      return `No email went to ${to}: its words were held for the office to look at, and a task says why.`;
    case 'no_address':
      return `No email went: ${to} has no email address on file. Add one and send them the invoice below, or ring them.`;
    case 'no_contact':
      return 'No email went: nobody is on file for this household to send it to.';
  }
}

function SendForm({
  invoiceId,
  today,
  onDone,
}: {
  invoiceId: string;
  today: string;
  onDone: (sentence: string) => void;
}) {
  const [squareInvoiceId, setSquareInvoiceId] = useState('');
  const [issuedOn, setIssuedOn] = useState(today);
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setProblem(null);
    if (!isDay(issuedOn)) {
      setProblem('The issue date has to be a real day.');
      return;
    }
    setBusy(true);
    try {
      const answer = await sendInvoice(invoiceId, {
        squareInvoiceId: orNull(squareInvoiceId),
        issuedOn,
      });
      onDone(
        `Sent${answer.number ? ` as ${answer.number}` : ''}. Due ${formatDay(answer.dueOn)}, under the published seven-day terms. ${invoiceEmailSentence(answer.email)}`,
      );
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card className="mb-4">
      <h2 className="font-serif text-lg">Send it</h2>
      <p className="mt-1 mb-3 text-sm text-navy/70">
        This records that it went, gives it the next invoice number, and starts the seven-day clock
        the terms publish. It also emails the invoice and their link to pay it to the person who
        pays, once its PDF is made.
      </p>
      <form onSubmit={submit} noValidate>
        {problem ? (
          <div className="mb-3">
            <ErrorNotice title="Not recorded" message={problem} />
          </div>
        ) : null}
        <TextField
          id="send-square-id"
          label="Square invoice id"
          value={squareInvoiceId}
          onChange={setSquareInvoiceId}
          autoComplete="off"
          hint="From Square, once it is raised there. Can be left blank and added later."
        />
        <TextField
          id="send-issued-on"
          label="Issued on"
          type="date"
          value={issuedOn}
          onChange={setIssuedOn}
        />
        <Button type="submit" full disabled={busy}>
          {busy ? 'Recording' : 'Mark it sent'}
        </Button>
      </form>
    </Card>
  );
}

/* ------------------------------------------------------------------ *
 * Money arrived, or money went back.
 * ------------------------------------------------------------------ */

/** Why the screen sends nothing, asks first and voids nothing while a bank payment clears, said once. */
const CLEARING_HOLDS =
  'While it clears the invoice is not sent to them again, a payment typed in here asks first, because the same money could be taken twice, and it cannot be voided, because their money would arrive for an invoice that bills nothing.';

/**
 * MONEY TYPED AGAINST AN INVOICE WHILE A BANK PAYMENT CLEARS ON IT asks first (the review of the staging
 * walk of 2026-09-23): a box naming that payment, its amount and when it started, which the office
 * ticks only for separate money, and the request then carries `despiteClearing`, which the server
 * requires while one clears and refuses without. A refund takes nothing from her twice and is not
 * asked. Where the bank payment began after the screen was read, the server's refusal says so.
 */
function PaymentForm({
  invoiceId,
  clientId,
  balanceCents,
  totalCents,
  today,
  clearing,
  owner,
  onDone,
}: {
  invoiceId: string;
  clientId: string;
  balanceCents: number;
  totalCents: number;
  today: string;
  /** A bank payment through Stripe on its way on this invoice, or null. */
  clearing: { readonly since: string; readonly amountCents: number } | null;
  /** An owner is typing, who alone may say an owner typed it in. */
  owner: boolean;
  onDone: (sentence: string) => void;
}) {
  // Nothing owed means the invoice is paid and the only thing left to record is money going back.
  // The box opens on the whole invoice because a full refund is the published remedy; it is a
  // prefill of money that already landed, never a price, and the person can type over it.
  const settled = balanceCents === 0;
  const prefillDollars = dollarsForInput(settled ? totalCents : balanceCents);
  const [kind, setKind] = useState<PaymentKind>(settled ? 'refund' : 'payment');
  const [method, setMethod] = useState<PaymentMethod | ''>('');
  // An owner starts on her own word; anybody else starts on nothing, and says which is true (ops #54,
  // item 4): the walk found a manager's entry stored as an owner's because the form started her there.
  // Every word stays hers to choose, since cash handed to the office is on no statement and in no
  // Square report, and the server records who typed it whichever she chooses.
  const [entrySource, setEntrySource] = useState<TypedEntrySource | ''>(
    owner ? 'owner_entered' : '',
  );
  const [dollars, setDollars] = useState(prefillDollars);
  const [tipDollars, setTipDollars] = useState('');
  const [receivedOn, setReceivedOn] = useState(today);
  const [reference, setReference] = useState('');
  const [squarePaymentId, setSquarePaymentId] = useState('');
  const [allocationDollars, setAllocationDollars] = useState(prefillDollars);
  /** The office's word that this is not the bank payment on its way. */
  const [separate, setSeparate] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  /** The bank payment money coming in asks about while it clears; money going back asks nothing. */
  const asks = kind === 'refund' ? null : clearing;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setProblem(null);
    const amount = centsFromDollars(dollars);
    const tip = tipDollars.trim() ? centsFromDollars(tipDollars) : 0;
    const allocation = centsFromDollars(allocationDollars);
    if (!method) {
      setProblem('Say how the money arrived.');
      return;
    }
    if (!entrySource) {
      setProblem('Say where this record came from.');
      return;
    }
    if (amount === null || amount === 0) {
      setProblem('That is not an amount. Type it in dollars, like 180 or 180.50.');
      return;
    }
    if (tip === null) {
      setProblem('The tip is not an amount. Leave it blank if there was none.');
      return;
    }
    if (allocation === null) {
      setProblem('Say how much of this goes against this invoice, in dollars.');
      return;
    }
    if (!isDay(receivedOn)) {
      setProblem('The day it arrived has to be a real day.');
      return;
    }
    if (asks && !separate) {
      setProblem(
        `A bank payment of ${money(asks.amountCents)} is still on its way for this invoice. Tick the box only if this is separate money.`,
      );
      return;
    }
    // A refund is a negative figure on the book. The person types it as money, the sign follows.
    const sign = kind === 'refund' ? -1 : 1;
    setBusy(true);
    try {
      const answer = await recordPayment({
        clientId,
        kind,
        method,
        entrySource,
        amountCents: sign * amount,
        tipCents: tip,
        receivedOn,
        reference: orNull(reference),
        squarePaymentId: orNull(squarePaymentId),
        allocations: allocation === 0 ? [] : [{ invoiceId, amountCents: sign * allocation }],
        ...(asks && separate ? { despiteClearing: true } : {}),
      });
      // Named by its receipt where it has one (ops #76 O2): a payment does, a refund does not.
      const recorded = answer.receiptNumber
        ? `Recorded as receipt ${answer.receiptNumber}`
        : 'Recorded';
      onDone(
        answer.unallocatedCents === 0
          ? `${recorded}, and the invoice knows about it.`
          : `${recorded}. ${money(Math.abs(answer.unallocatedCents))} of it is not against any invoice yet.`,
      );
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <details className="mb-4 rounded-xl border border-navy/12 bg-parchment p-4">
      <summary className="min-h-11 desk:min-h-9 cursor-pointer font-serif text-lg">
        {settled ? 'Record a refund' : 'Record a payment'}
      </summary>
      <p className="mt-2 text-sm text-navy/70">
        {settled
          ? 'This invoice is paid. Money that went back to the client is recorded here, against it, so the book and the promise agree.'
          : 'Money that arrived, however it arrived. Square reports its own; a Zelle transfer or a check is typed in here so the share Square cannot see is a number and not a feeling.'}
      </p>
      <form className="mt-3" onSubmit={submit} noValidate>
        {problem ? (
          <div className="mb-3">
            <ErrorNotice title="Not recorded" message={problem} />
          </div>
        ) : null}
        <SelectField
          id="pay-kind"
          label="What this is"
          value={kind}
          onChange={setKind}
          options={PAYMENT_KINDS}
          toLabel={(option) => PAYMENT_KIND_LABELS[option]}
          hint={
            kind === 'refund'
              ? 'Typed as money, the way it left. It goes on the book as a negative figure.'
              : undefined
          }
        />
        <SelectField
          id="pay-method"
          label="How it arrived"
          required
          value={method}
          onChange={setMethod}
          options={PAYMENT_METHODS}
          toLabel={(option) => PAYMENT_METHOD_LABELS[option]}
          placeholder="Choose one"
        />
        <SelectField
          id="pay-source"
          label="Where this record came from"
          required={!owner}
          value={entrySource}
          onChange={setEntrySource}
          options={TYPED_ENTRY_SOURCES}
          toLabel={(option) => ENTRY_SOURCE_LABELS[option]}
          {...(owner
            ? {}
            : {
                placeholder: 'Choose one',
                hint: 'Choose the one that is true. Who typed it in is kept with the record either way.',
              })}
        />
        <TextField
          id="pay-amount"
          label="Amount"
          required
          inputMode="numeric"
          value={dollars}
          onChange={setDollars}
          hint="Dollars, like 180 or 180.50. Not including any tip."
        />
        <TextField
          id="pay-tip"
          label="Tip"
          inputMode="numeric"
          value={tipDollars}
          onChange={setTipDollars}
          hint="Passed through in full to the cleaner who earned it. Blank if none."
        />
        <TextField
          id="pay-received"
          label="Arrived on"
          type="date"
          required
          value={receivedOn}
          onChange={setReceivedOn}
        />
        <TextField
          id="pay-reference"
          label="Reference"
          value={reference}
          onChange={setReference}
          autoComplete="off"
          hint="The check number or the Zelle confirmation, for the monthly close."
        />
        {entrySource === 'square' ? (
          <TextField
            id="pay-square"
            label="Square payment id"
            value={squarePaymentId}
            onChange={setSquarePaymentId}
            autoComplete="off"
          />
        ) : null}
        <TextField
          id="pay-allocation"
          label="Against this invoice"
          inputMode="numeric"
          value={allocationDollars}
          onChange={setAllocationDollars}
          hint={
            settled
              ? `Dollars. Nothing is owed on it; ${money(totalCents)} was paid, and a refund goes against it as a negative figure. Anything unallocated stays on the household's book.`
              : `Dollars. ${money(balanceCents)} is still owed on it. Anything unallocated stays on the household's book.`
          }
        />
        {asks ? (
          <div className="mb-3 rounded-lg border border-gold/50 bg-gold/10 p-3">
            <div className="flex items-start gap-3">
              <input
                id="pay-despite-clearing"
                type="checkbox"
                checked={separate}
                onChange={(event) => setSeparate(event.currentTarget.checked)}
                className="mt-1 h-5 w-5 shrink-0 accent-navy"
              />
              <label htmlFor="pay-despite-clearing" className="text-sm">
                {`This is separate money, not the bank payment of ${money(asks.amountCents)} that started ${formatInstant(asks.since) ?? asks.since}.`}
              </label>
            </div>
          </div>
        ) : null}
        <Button type="submit" full disabled={busy}>
          {busy ? 'Recording' : 'Record it'}
        </Button>
      </form>
    </details>
  );
}

/* ------------------------------------------------------------------ *
 * Her report through home that she sent it by Zelle (ops #71 item 5).
 * ------------------------------------------------------------------ */

/**
 * WHAT THE OFFICE IS TOLD OF HER ZELLE REPORT, the one place these words are spelled. Office words,
 * never hers: what she said through home and that nothing is paid until the office records it, the
 * question before a clear by what her saved method's charge does once it is cleared, what the server
 * said the clear did, and who cleared it.
 */
const ZELLE_REPORT_WORDS = {
  heading: 'Their Zelle report',
  standing: (reportedAt: string, amountCents: number, sentOn: string): string =>
    `They said through home on ${formatDay(dayOf(reportedAt)) ?? reportedAt} that they sent ${money(amountCents)} by Zelle on ${formatDay(sentOn) ?? sentOn}. Nothing is paid until you record it.`,
  clear: 'Clear the Zelle report',
  clearing: 'Clearing',
  yes: 'Yes, clear it',
  notNow: 'Not now',
  askWithNoCharge:
    'This says their Zelle is not coming, so their page stops saying it is on its way and offers every way to pay again. Nothing is recorded as paid. Clear it only once you have spoken with them.',
  askWithThePause:
    "This says their Zelle is not coming, so their page stops saying it is on its way. Their saved payment method's charge stays paused until you then press Lift the pause, so it goes ahead, or Do not charge this one. Nothing is recorded as paid. Clear it only once you have spoken with them.",
  /** Where her saved method's charge pays it with no pause of hers beside it, held by her report alone. */
  askWithTheCharge:
    "This says their Zelle is not coming, so their page stops saying it is on its way. Their saved payment method's charge on this invoice is not paused, so it then goes ahead as it would have, unless you press Do not charge this one. Nothing is recorded as paid. Clear it only once you have spoken with them.",
  cleared: 'Cleared. Their page no longer says their Zelle is on its way.',
  clearedGoesAhead:
    "Cleared. Their page no longer says their Zelle is on its way, and their saved payment method's charge is no longer held for their Zelle: it goes ahead as it would have.",
  clearedBy: (who: string | null, at: string): string =>
    `${who ?? 'The office'} cleared their Zelle report, ${formatInstant(at) ?? at}.`,
  /** Under the charge, where "Lift the pause" would be while her report stands. */
  liftWaits: 'Clear their Zelle report before lifting the pause.',
} as const;

/**
 * HER REPORT THROUGH HOME THAT SHE SENT IT BY ZELLE (ops #71 item 5), beside the money: while it
 * stands, what she said, how much and on which day, and that nothing is paid until the office records
 * her Zelle when it comes; and "Clear the Zelle report" for a Zelle that is not coming, asked once more,
 * since it decides what her page says, in words that say what happens to her saved method's charge
 * where one pays the invoice: it stays paused while her pause stands, and otherwise goes ahead once
 * cleared. Once cleared, who cleared it and when, and no door. The amount is what the invoice still
 * owes, which is what her page asked her to send.
 */
function ZelleReportPanel({
  invoiceId,
  report,
  balanceCents,
  chargeNext,
  onDone,
}: {
  invoiceId: string;
  report: InvoiceZelleReport;
  balanceCents: number;
  /** What her saved method's charge does once her report is cleared, as the invoice was read. */
  chargeNext: ChargeAfterClear;
  onDone: (sentence: string) => void;
}) {
  const [confirming, setConfirming] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function clear() {
    setBusy(true);
    setProblem(null);
    try {
      // The server's word on the charge governs, read at the moment of the clear.
      const answer = await clearZelleReport(invoiceId);
      setConfirming(false);
      onDone(
        answer.chargeNext === 'goes_ahead'
          ? ZELLE_REPORT_WORDS.clearedGoesAhead
          : ZELLE_REPORT_WORDS.cleared,
      );
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section
      aria-label={ZELLE_REPORT_WORDS.heading}
      className="mb-4 rounded-xl border border-gold/50 bg-gold/10 p-4"
    >
      <h2 className="font-serif text-lg">{ZELLE_REPORT_WORDS.heading}</h2>
      {problem ? (
        <div className="mt-2">
          <ErrorNotice title="Not done" message={problem} />
        </div>
      ) : null}
      {report.stands ? (
        <>
          <p className="mt-2 text-sm">
            {ZELLE_REPORT_WORDS.standing(report.reportedAt, balanceCents, report.sentOn)}
          </p>
          {confirming ? (
            <div className="mt-3 rounded-lg border border-navy/15 bg-cream p-3 text-sm">
              <p className="mb-2">
                {chargeNext === 'stays_paused'
                  ? ZELLE_REPORT_WORDS.askWithThePause
                  : chargeNext === 'goes_ahead'
                    ? ZELLE_REPORT_WORDS.askWithTheCharge
                    : ZELLE_REPORT_WORDS.askWithNoCharge}
              </p>
              <div className="flex flex-wrap gap-2">
                <Button disabled={busy} onClick={() => void clear()}>
                  {busy ? ZELLE_REPORT_WORDS.clearing : ZELLE_REPORT_WORDS.yes}
                </Button>
                <Button tone="quiet" disabled={busy} onClick={() => setConfirming(false)}>
                  {ZELLE_REPORT_WORDS.notNow}
                </Button>
              </div>
            </div>
          ) : (
            <div className="mt-3">
              <Button tone="quiet" disabled={busy} onClick={() => setConfirming(true)}>
                {ZELLE_REPORT_WORDS.clear}
              </Button>
            </div>
          )}
        </>
      ) : report.clearedAt !== null ? (
        <p className="mt-2 text-sm">
          {ZELLE_REPORT_WORDS.clearedBy(report.clearedBy, report.clearedAt)}
        </p>
      ) : null}
    </section>
  );
}

/* ------------------------------------------------------------------ *
 * Send the invoice.
 * ------------------------------------------------------------------ */

/** The two ways her link can reach her. A phone call carries no link. */
const INVOICE_CHANNELS = ['sms', 'email'] as const;
type InvoiceChannel = (typeof INVOICE_CHANNELS)[number];
/** The one way while pay links by text are off, which is until an owner allows them (ops #21). */
const EMAIL_ONLY: readonly InvoiceChannel[] = ['email'];

/**
 * THE WORDS THE FORM STARTS FROM (ops #46): what is still owed, the question "How did we do?" with
 * how to answer it (step 2) in an email and never in a text, since a feedback request is never texted
 * (faithfully-kept-phone#27, ops #76 O6), Zelle named first with the tag decoded from the one stored code (`ZELLE`,
 * never typed here) and the invoice's memo, its number once it has one and the day of the visit
 * before (ops #76 O2), then her link, where every way to pay is and where the
 * four faces are. A service question and never a request for a public review. Only what the invoice holds and one plain fact about paying, no claim about the
 * business (binding rule 8), and never a price that differs by how she pays (binding rule 3). A text
 * ends with the opt-out line the phone system looks for and an email does not (ops #23). The link ends
 * its sentence with no full stop, so a phone that makes it tappable takes none into the address.
 *
 * AN INVOICE HER SAVED METHOD PAYS (step 3b, `charged`, her method in her words) says that instead
 * of Zelle: her method is charged once she tells us the clean went well, which is the only way it
 * ever is for a first charge. Her page offers Zelle in the charge's place, so the link is her invoice
 * rather than every way to pay. BY THE RULE HER PAGE KEEPS (the review of the staging walk of
 * 2026-09-23), where the words said her receipt was emailed whoever the payer was and never said
 * when: an email names the business hours an owner set, which the charge runs inside alone, and says a
 * receipt is emailed only where one goes (`receiptGoesByEmail` on the server). A text says the receipt
 * the same way and leaves the hours to her page: the phone system takes a text in three parts, and at
 * the longest label, amount, host and business day the hours spelled out would not fit.
 *
 * AT HOME (`atHome`: a host whose clients reach home, `CLIENT_PAGES_AT_HOME`;
 * `docs/plan-clients-only-home.md` concern B1c) her link is her invoice page at home, and an email
 * carries the owner's sign-in sentence of 2026-10-19 after it, word for word, as a paragraph of its own
 * (`SIGN_IN_LINE`, D13), so the link still ends its line. A text carries no such sentence: the approved
 * one names the email address the message was sent to, which a text was not. Told nothing of home, the
 * words are the words of today.
 */
export function invoiceSentence(input: {
  readonly issuedOn: string | null;
  readonly balanceCents: number;
  readonly memo: string;
  readonly link: string;
  readonly channel: InvoiceChannel;
  readonly charged?: {
    /** Her method in her words, "Visa ending 4242". */
    readonly method: string;
    /** The business day it is charged inside, or null where the read did not say. */
    readonly businessHours: WhenCharged['businessHours'] | null;
    readonly receiptByEmail: boolean;
  } | null;
  /** Her link is her invoice page at home, on a host whose clients reach home. */
  readonly atHome?: boolean;
}): string {
  const which = input.issuedOn ? `Your invoice of ${formatDay(input.issuedOn)}` : 'Your invoice';
  const charged = input.charged ?? null;
  const when =
    charged === null
      ? ''
      : input.channel === 'email'
        ? `${charged.businessHours ? ` during business hours: ${businessHoursWords(charged.businessHours)}` : ''}.${charged.receiptByEmail ? ' A receipt is emailed when it is charged.' : ''}`
        : `${charged.receiptByEmail ? ' and email your receipt' : ''}.`;
  const howToPay = charged
    ? `Once you tell us the clean went well we will charge your ${charged.method}${when} Your invoice is here: ${input.link}`
    : `The easiest way to pay is Zelle to ${ZELLE.tag}, memo ${input.memo}. Every way to pay is on your invoice: ${input.link}`;
  // A feedback request is never texted (faithfully-kept-phone#27, ops #76 O6), so the question goes in
  // the words of an email alone.
  const question = input.channel === 'email' ? ` ${EMAIL_QUESTION}` : '';
  const sentence = `Hi, this is Faithfully Kept. ${which} has ${money(input.balanceCents)} still owed.${question} ${howToPay}`;
  if (input.channel === 'sms') return `${sentence} ${OPT_OUT_LINE}`;
  return input.atHome ? `${sentence}\n\n${SIGN_IN_LINE}` : sentence;
}

/** The question an invoice email asks, and a text does not: how the clean went, and how to answer. */
const EMAIL_QUESTION = 'How did we do? Tap the link to tell us, or reply here.';

/**
 * Her link once it is made: the whole address she taps, when it stops working, and who it is for. Her
 * invoice page at home has no end of ours (`expiresAt` null): the address is where, home's code is who.
 */
interface HerLink {
  readonly url: string;
  readonly expiresAt: string | null;
  readonly contactId: string;
}

/**
 * WHAT THE OFFICE IS TOLD OF HER INVOICE PAGE AT HOME (concern B1d, D8), the one place these words are
 * spelled. Office words, never a client's: hers are the approved ones in `invoiceSentence`. Why it would
 * not open for her is said as the server says it when it refuses the send (`no_home_door`,
 * `contact_has_no_email` in `api/src/money/pay-link.ts`), with what the office does next.
 */
export const AT_HOME_OFFICE_WORDS = Object.freeze({
  forHer: (name: string): string =>
    `For ${name}. Their link is their invoice page at home, which may ask them to sign in by a code emailed to them.`,
  noDoor: (name: string): string =>
    `${name} holds no door onto home as a client, so their invoice page there would not open for them. Invite them from the household screen first.`,
  member: (name: string): string =>
    `${name} is a member at home, and home shows a member no money, so their invoice page there would not open for them. Invite them as a client from the household screen first.`,
  numberOnly: (name: string): string =>
    `${name} has no email address on file, and their invoice page at home signs them in by a code emailed to them. Add their address if they have one, or call them.`,
  noHandOff:
    'The phone system is not connected to this deployment yet, so copy their invoice page at home from Send them a link into a text or an email.',
  panelIntro:
    'Their invoice page at home, for one person of the household, to copy into a message yourself. It opens for a person who holds a door onto home as a client, and may ask them to sign in by a code emailed to them. Nothing is made here, and no link of ours goes to a client.',
  show: 'Show their page',
  shownLabel: 'Their invoice page at home',
  shownNote:
    'The same address for anyone who may open it. Nothing was made, so there is nothing to withdraw.',
});

/** Her invoice page at home for one person, or why it would not open for her. */
export type HerPageAtHome = { readonly page: string } | { readonly why: string };

/**
 * HER INVOICE PAGE AT HOME, PAST THE DOOR GATE, as the office's screens read it (concern B1d, D8): the
 * page for a person who holds a live `client` door there, and for anyone else why not. A person with no
 * email address is told so first, whatever her door: home signs her in by a code emailed to her until
 * texted codes exist (the owner's answer (c) of 2026-10-19), and an email needs an address anyway. Then
 * a `member`, whom home shows no money, and a person with no door, each invited from the household
 * screen. Reads nothing: the server named the page and the doors with the invoice.
 */
export function herPageAtHome(
  atHome: InvoiceAtHome,
  person: Pick<ContactRow, 'id' | 'displayName' | 'email'>,
): HerPageAtHome {
  const name = person.displayName;
  if (!person.email?.trim()) return { why: AT_HOME_OFFICE_WORDS.numberOnly(name) };
  const roles = atHome.doors
    .filter((door) => door.contactId === person.id)
    .map((door) => door.role);
  if (roles.includes('client')) return { page: atHome.invoiceUrl };
  if (roles.includes('member')) return { why: AT_HOME_OFFICE_WORDS.member(name) };
  return { why: AT_HOME_OFFICE_WORDS.noDoor(name) };
}

/**
 * WHY THE SAVED METHOD THAT STANDS DOES NOT PAY THIS INVOICE, in one sentence for the office, from the
 * invoice's own charge (ops #46, step 4): an invoice issued before the method was saved carries none;
 * otherwise the charge declined, waited on her bank's confirmation, did not go through, was stopped by
 * the office, ended because its method was stopped or the invoice was paid another way, or went
 * through, after which money handed back is never charged again. Each hands the invoice back to every
 * way to pay, and the sentence says which happened rather than guess.
 */
export function whyNotCharged(label: string, charge: InvoiceCharge | null): string {
  const saved = `${label} is saved for automatic charges, but `;
  const everyWay = 'their page offers every way to pay.';
  const stopped = `this invoice was to be charged to a saved method since stopped, so it is not charged automatically and ${everyWay}`;
  if (charge === null) {
    return `${saved}this invoice was issued before it was, so it is not charged automatically and ${everyWay}`;
  }
  switch (charge.state) {
    case 'declined':
      return `${saved}the automatic charge of this invoice was declined, so it is not charged again and ${everyWay}`;
    case 'needs_authentication':
      return `${saved}their bank wanted them to confirm the automatic charge of this invoice themselves, so their page offers every way to pay, and its card page asks their bank to confirm it.`;
    case 'failed':
      return `${saved}the automatic charge of this invoice did not go through, so ${everyWay}`;
    case 'succeeded':
      return `${saved}the automatic charge of this invoice went through, and what a refund or a dispute left owing is not charged again, so ${everyWay}`;
    case 'cancelled':
      if (charge.cancelReason === 'office_cancelled') {
        return `${saved}the office said not to charge this invoice automatically, so ${everyWay}`;
      }
      if (charge.cancelReason === 'paid_another_way') {
        return `${saved}this invoice was paid another way, so its automatic charge ended, and what it owes now is not charged automatically: ${everyWay}`;
      }
      return `${saved}${stopped}`;
    default:
      // Not yet claimed, and not paying the invoice: the method it was written under has been stopped.
      return `${saved}${stopped}`;
  }
}

function SendInvoicePanel({
  invoice,
  balanceCents,
  canHandOff,
  byText,
  texting,
  emailing,
  stripeOn,
  autopay,
  charge,
  atHome,
  onChanged,
}: {
  invoice: InvoiceRow;
  balanceCents: number;
  canHandOff: boolean;
  /** Whether it may go by text, which it may not until an owner allows it (ops #21). */
  byText: boolean;
  /** Where ops's go-live switch for texts stands (ops #31), which a text goes past too. */
  texting: SmsGoLive | null;
  /** Where ops's go-live switch for client email stands (ops #76 O6), which an email goes past. */
  emailing: EmailGoLive | null;
  /** Whether her page can offer a bank account and a card, which needs a Stripe key here. */
  stripeOn: boolean;
  /** The household's saved method, if one stands, and whether it pays this invoice (step 3b). */
  autopay: InvoiceAutopay | null;
  /** The invoice's own automatic charge, which says why the method does not pay it (step 4). */
  charge: InvoiceCharge | null;
  /**
   * Her invoice page at home and the household's doors there, on a host whose clients reach home
   * (concern B1d): the words carry that page and no link of ours is made. Null, the screen of today.
   */
  atHome: InvoiceAtHome | null;
  /**
   * Her link is made, or the words were handed on: the screen reads the invoice again, so its list of
   * links is current and "How did we do?" says where the question the words ask stands now.
   */
  onChanged: () => void;
}) {
  // Her method in her words, when it is the one that pays this invoice, with when it is charged and
  // whether a receipt goes by email, and the words say so by the rule her page keeps.
  const charged = autopay?.coversThisInvoice
    ? {
        method: savedMethodWords(autopay),
        businessHours: autopay.whenCharged?.businessHours ?? null,
        receiptByEmail: autopay.whenCharged?.receiptByEmail ?? false,
      }
    : null;
  const [contacts, setContacts] = useState<readonly ContactRow[] | null>(null);
  const [contactsProblem, setContactsProblem] = useState<string | null>(null);
  const [contactId, setContactId] = useState('');
  // While text is off every invoice goes by email, so the form starts there and stays there; and it
  // starts there too until the go-live switch lets every text go (ops #31).
  const [channel, setChannel] = useState<InvoiceChannel>(
    byText && textingPath(texting, null).open ? 'sms' : 'email',
  );
  const [hers, setHers] = useState<HerLink | null>(null);
  const [body, setBody] = useState('');
  const [problem, setProblem] = useState<string | null>(null);
  const [refused, setRefused] = useState<string | null>(null);
  const [sent, setSent] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!canHandOff) return;
    let live = true;
    setContactsProblem(null);
    getClient(invoice.clientId)
      .then((answer) => {
        if (live) setContacts(answer.contacts);
      })
      .catch((thrown: unknown) => {
        if (!live) return;
        setContactsProblem(
          thrown instanceof ApiError ? thrown.message : 'The household did not load.',
        );
      });
    return () => {
      live = false;
    };
  }, [invoice.clientId, canHandOff]);

  const nameOf = (id: string) => contacts?.find((contact) => contact.id === id)?.displayName;
  // Whether a text to the person chosen would go past ops's go-live switch (ops #31).
  const chosen = contacts?.find((contact) => contact.id === (hers?.contactId ?? contactId));
  const gate = textingPath(texting, chosen?.phoneE164 ?? null);
  const textHeld = channel === 'sms' && !gate.open;
  // And whether an email to her address would go past ops's switch for client email (ops #76 O6).
  const mailGate = emailPath(emailing, chosen?.email ?? null);
  const emailHeld = channel === 'email' && !mailGate.open;
  // The invoice's number once it has one, else the day of the clean: the same memo her page shows
  // beside the tag, from the same function (ops #76 O2).
  const memo = invoiceMemo({ number: invoice.number, day: invoice.visitDate });
  const sentenceFor = (way: InvoiceChannel, url: string) =>
    invoiceSentence({
      issuedOn: invoice.issuedOn,
      balanceCents,
      memo,
      link: url,
      channel: way,
      charged,
      // At home an email carries the owner's sign-in sentence after her page (concern B1c).
      ...(atHome !== null ? { atHome: true } : {}),
    });

  /**
   * A change of channel takes the words with it only while they are still the words this form
   * offered for the old one, so the opt-out line comes and goes with the text. Words somebody wrote
   * are hers, and a channel never rewrites them.
   */
  function switchTo(next: InvoiceChannel) {
    if (hers) {
      setBody((words) =>
        words === sentenceFor(channel, hers.url) ? sentenceFor(next, hers.url) : words,
      );
    }
    setChannel(next);
  }

  // The channel follows the person: the way she prefers, or email when there is no number to text,
  // or when ops's go-live switch would hold a text to hers and she has an address (ops #31). Until an
  // owner allows text it is email whoever she is (ops #21).
  function pick(id: string) {
    setContactId(id);
    if (!byText) return;
    const contact = contacts?.find((row) => row.id === id);
    if (!contact) return;
    const held = !textingPath(texting, contact.phoneE164).open;
    const byEmail =
      contact.preferredChannel === 'email' ||
      (!contact.phoneE164 && !!contact.email) ||
      (held && !!contact.email);
    switchTo(byEmail ? 'email' : 'sms');
  }

  /**
   * Her link, made for the person chosen, and the words around it put in front of the office. At home
   * nothing is made: her invoice page there, where she holds a `client` door, or why not (D8).
   */
  async function makeHerLink() {
    setProblem(null);
    setRefused(null);
    if (!contactId) {
      setProblem('Choose who it is for.');
      return;
    }
    if (atHome !== null) {
      const person = contacts?.find((contact) => contact.id === contactId);
      if (!person) {
        setProblem('Choose who it is for.');
        return;
      }
      const hersAtHome = herPageAtHome(atHome, person);
      if ('why' in hersAtHome) {
        setProblem(hersAtHome.why);
        return;
      }
      setHers({ url: hersAtHome.page, expiresAt: null, contactId });
      setBody(sentenceFor(channel, hersAtHome.page));
      return;
    }
    setBusy(true);
    try {
      const made = await createGrant({ targetKind: 'invoice', targetId: invoice.id, contactId });
      const url = `${window.origin}${made.path}`;
      setHers({ url, expiresAt: made.expiresAt, contactId });
      setBody(sentenceFor(channel, url));
      onChanged();
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'Their link was not made.');
    } finally {
      setBusy(false);
    }
  }

  /** Back to choosing. A link already made stays on the list below, where it can be withdrawn. */
  function startAgain() {
    setHers(null);
    setBody('');
    setContactId('');
    setProblem(null);
    setRefused(null);
  }

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!hers) return;
    setProblem(null);
    setRefused(null);
    if (textHeld) {
      setProblem(gate.why);
      return;
    }
    if (emailHeld) {
      setProblem(mailGate.why);
      return;
    }
    const name = nameOf(hers.contactId) ?? 'this person';
    setBusy(true);
    try {
      const answer = await sendPayLink(invoice.id, { contactId: hers.contactId, channel, body });
      if (answer.refusedByConsent) {
        // What the register said, never that she did not agree: a stop or a do-not-contact mark refuses
        // her over a yes on record (concern 14's review). No words from the server, no reason claimed.
        setRefused(
          answer.refusal
            ? `Nothing was sent to ${name}. The register refused it: ${answer.refusal}. Ring them, or copy their link to them another way.`
            : `Nothing was sent to ${name}: the register refused it, and the record says why. Ring them, or copy their link to them another way.`,
        );
      } else if (answer.gateRefusal) {
        // Ops's own go-live switch held it (ops #31), or client email's held an email (ops #76 O6):
        // written, parked, and the record says so.
        setRefused(
          heldByEmailSwitch(answer.gateRefusal)
            ? `Nothing was sent to ${name}: client email is not on in ops for their address, and the record says so. Copy their link to them another way.`
            : `Nothing was sent to ${name}: texting is not on in ops for their number, and the record says so. Send it by email, or copy their link to them another way.`,
        );
      } else if (answer.choiceRefusal) {
        // Their own choice, or the office's hold (ops #76 phase 2): written, parked, and said so.
        setRefused(choiceSentOf(name, answer.choiceRefusal, answer.officeCalls));
      } else {
        // A text goes to the phone system, and an email to home, which sends it from home@ (ops #76 O6).
        setSent(
          channel === 'sms'
            ? `Recorded, and waiting for the phone system to send it to ${name} by text.`
            : `Recorded, and waiting for home to send it to ${name} by email.`,
        );
      }
      // The send moved the question the words ask, refused or not: "How did we do?" reads it again
      // rather than saying "Never delivered" until the page is loaded again (the walk of 2026-09-23).
      onChanged();
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  const channelField = (
    <SelectField
      id="invoice-channel"
      label="How it goes"
      value={channel}
      onChange={switchTo}
      options={byText ? INVOICE_CHANNELS : EMAIL_ONLY}
      toLabel={(value) => MESSAGE_CHANNEL_LABELS[value]}
      hint={byText ? undefined : 'Pay links go by email for now.'}
    />
  );
  // Where ops's go-live switch stands, under a text alone, and its switch for client email under an
  // email alone (ops #76 O6).
  // What their choices would do to it (ops #76 phase 2), at every home: the words it would be parked
  // with, and the guard line where the office would be given the call.
  const chosenLine = choiceLineOf(chosen?.messaging?.choices?.invoices?.[channel]);
  const gateLine = (
    <>
      {channel === 'sms' ? (
        <TextingGate
          path={gate}
          wayOn="Send it by email, or copy their link to them another way."
        />
      ) : (
        <EmailGate path={mailGate} wayOn="Copy their link to them another way." />
      )}
      {chosenLine !== null ? (
        <p
          id="invoice-choice"
          className="mb-3 rounded-lg border border-coral/50 border-l-4 border-l-coral bg-parchment px-3 py-2 text-sm wrap-anywhere"
        >
          {chosenLine}
        </p>
      ) : null}
    </>
  );

  return (
    <Card className="mb-4">
      <h2 className="font-serif text-lg">Send the invoice</h2>
      {charged && autopay ? (
        <p className="mt-1 mb-3 text-sm text-navy/70">
          Their own link to this invoice, in words they read. {autopay.displayLabel} is saved to pay
          this invoice automatically, once they tell us the clean went well. Their page asks how it
          went and offers Zelle in the charge&apos;s place, and no bank account or card.
        </p>
      ) : (
        <p className="mt-1 mb-3 text-sm text-navy/70">
          Their own link to this invoice, in words they read. Their page offers Zelle first, then
          their bank account, then a card, at the same {money(balanceCents)} whichever they choose.
        </p>
      )}
      {autopay && !charged && stripeOn ? (
        <p className="mb-3 text-sm">{whyNotCharged(autopay.displayLabel, charge)}</p>
      ) : null}
      {stripeOn ? null : (
        <p className="mb-3 text-sm">
          Stripe is not switched on here, so their page offers Zelle and the office&apos;s number,
          and no bank account or card.
        </p>
      )}

      {problem ? (
        <div className="mb-3">
          <ErrorNotice title="Not done" message={problem} />
        </div>
      ) : null}
      {refused ? (
        <div className="mb-3">
          <ErrorNotice title="Not sent" message={refused} />
        </div>
      ) : null}

      {!canHandOff ? (
        atHome !== null ? (
          <p className="text-sm text-navy/70">{AT_HOME_OFFICE_WORDS.noHandOff}</p>
        ) : (
          <p className="text-sm text-navy/70">
            The phone system is not connected to this deployment yet, so make them a link under Send
            them a link, and copy it into a text or an email.
          </p>
        )
      ) : sent ? (
        <SavedNotice>{sent}</SavedNotice>
      ) : contactsProblem ? (
        <ErrorNotice title="The household did not load" message={contactsProblem} />
      ) : contacts === null ? (
        <Busy what="the household" />
      ) : contacts.length === 0 ? (
        <p className="text-sm text-coral">
          Nobody is on file for this household, so there is nobody to send the invoice to.
        </p>
      ) : hers === null ? (
        <div>
          <SelectField
            id="invoice-contact"
            label="Who it is for"
            required
            value={contactId}
            onChange={pick}
            options={contacts.map((contact) => contact.id)}
            toLabel={(id) => nameOf(id) ?? id}
            placeholder="Choose the person"
          />
          {channelField}
          {gateLine}
          <Button onClick={() => void makeHerLink()} disabled={busy}>
            {busy ? 'Making their link' : 'Send the invoice'}
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} noValidate>
          {hers.expiresAt === null ? (
            <p className="mb-3 text-sm">
              {AT_HOME_OFFICE_WORDS.forHer(nameOf(hers.contactId) ?? 'them')}
            </p>
          ) : (
            <p className="mb-3 text-sm">
              For {nameOf(hers.contactId) ?? 'them'}. Their link works until{' '}
              {formatInstant(hers.expiresAt)}.
            </p>
          )}
          {channelField}
          {gateLine}
          <TextAreaField
            id="invoice-body"
            label="What they will read"
            rows={6}
            value={body}
            onChange={setBody}
            hint="Edit it as you like. It has to keep their link exactly as it is."
          />
          <Button type="submit" full disabled={busy || textHeld || emailHeld}>
            {busy ? 'Recording' : 'Send it'}
          </Button>
          <div className="mt-2">
            <Button tone="quiet" onClick={startAgain} disabled={busy}>
              Start again
            </Button>
          </div>
        </form>
      )}
    </Card>
  );
}

/* ------------------------------------------------------------------ *
 * How did we do.
 * ------------------------------------------------------------------ */

/** One answer, in a line: the face, the part of the home, her words, the door, and when. */
function answerLine(answer: InvoiceAnswer): string {
  const door = answer.recordedByName
    ? `${FEEDBACK_SOURCE_LABELS[answer.source]}, ${answer.recordedByName}`
    : FEEDBACK_SOURCE_LABELS[answer.source];
  return `${door}, ${formatInstant(answer.createdAt) ?? answer.createdAt}`;
}

/** What a hold stops while a bank payment clears on the invoice, and what it does not. */
const HOLD_WHILE_CLEARING =
  'A hold stops the reminder, the call from the office and the automatic charge. It does not stop the bank payment already on its way.';

/** What a hold that stands does while a bank payment clears on the invoice. */
const HELD_WHILE_CLEARING =
  'The reminder, the call and the automatic charge wait until it is released. The bank payment already on its way is not stopped by it.';

/**
 * "HOW DID WE DO?" ON THE INVOICE. A hold stops everything further on an invoice that is owed, the
 * reminder, the call and the automatic charge, so it is offered, and so is its release, only while
 * money is owed (`owed`): on an invoice paid or written off there is nothing further for it to stop,
 * and the walk of 2026-09-23 found both still offered there. What she said, the issue it opened and
 * an answer she rang with still matter once it is paid, and stay.
 */
function SurveyPanel({
  invoiceId,
  survey,
  answers,
  owed,
  clearing,
  onDone,
}: {
  invoiceId: string;
  survey: InvoiceSurvey | null;
  answers: readonly InvoiceAnswer[];
  /** Money is still owed on the invoice, so a hold still has something to stop. */
  owed: boolean;
  /**
   * A bank payment through Stripe is on its way on the invoice (ops #54, item 3): a hold and her answer
   * still stop what waits on the invoice, and never the payment already on its way, and say so.
   */
  clearing: boolean;
  onDone: (sentence: string) => void;
}) {
  const [face, setFace] = useState<FeedbackFace | ''>('');
  const [area, setArea] = useState('');
  const [line, setLine] = useState('');
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  /** On a refusal the server's sentence is shown and nothing typed is touched. */
  async function run(work: () => Promise<unknown>, sentence: string) {
    setBusy(true);
    setProblem(null);
    try {
      await work();
      onDone(sentence);
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  function record(event: FormEvent) {
    event.preventDefault();
    if (!face) {
      setProblem('Choose the face they gave.');
      return;
    }
    const body: FeedbackBody = {
      face,
      ...(area.trim() ? { area: area.trim() } : {}),
      ...(line.trim() ? { line: line.trim() } : {}),
    };
    void run(() => answerSurvey(invoiceId, body), 'Recorded.');
  }

  return (
    <section
      aria-label="How did we do?"
      className="mb-4 rounded-xl border border-navy/12 bg-parchment p-4"
    >
      <h2 className="font-serif text-lg">How did we do?</h2>
      {problem ? (
        <div className="mt-2">
          <ErrorNotice title="Not recorded" message={problem} />
        </div>
      ) : null}

      {survey ? (
        <>
          <dl className="mt-2">
            <Detail
              label="Asked"
              value={`${survey.contactName ?? 'The household'}, ${formatInstant(survey.askedAt)}`}
            />
            <Detail label="Where it stands" value={SURVEY_STATE_LABELS[survey.state]} />
            <Detail label="Delivered" value={formatInstant(survey.deliveredAt)} />
            {/* PAST THE REMINDER WITH NONE SENT is a reminder the ladder could not send (step 2b):
                her link had stopped working, there was nowhere to send it, a text while pay links
                by text are off, or the consent register refused it. The call still comes, and the
                follow-up it raises says which. AT THE CALL WITH NONE ASKED FOR, the register says
                not to call her, or her contact is gone, and nobody is asked to. */}
            <Detail
              label="The reminder"
              value={
                survey.reminded
                  ? 'Sent'
                  : survey.state === 'call_raised' && !survey.callRaised
                    ? 'Not sent.'
                    : survey.state === 'reminded' || survey.state === 'call_raised'
                      ? 'Not sent. The office is asked to call instead.'
                      : survey.reminderDueAt
                        ? `Due ${formatInstant(survey.reminderDueAt)}`
                        : null
              }
            />
            <Detail
              label="A call from the office"
              value={
                survey.callRaised
                  ? 'Asked for, on the follow-ups'
                  : survey.state === 'call_raised'
                    ? 'Not asked for: the register says not to call them, or they are no longer a contact.'
                    : survey.callDueAt
                      ? `Due ${formatInstant(survey.callDueAt)}`
                      : null
              }
            />
            <Detail
              label="Their answer"
              value={
                survey.latestFace
                  ? `${FEEDBACK_FACE_LABELS[survey.latestFace]}, first answered ${formatInstant(survey.answeredAt)}`
                  : 'Not answered yet.'
              }
            />
          </dl>
          {survey.held && owed ? (
            <div className="mt-2 rounded-lg border border-coral/40 bg-coral/10 p-3 text-sm">
              <p>
                Held:{' '}
                {survey.holdReason ? SURVEY_HOLD_REASON_LABELS[survey.holdReason] : 'by the office'}
                .{' '}
                {clearing
                  ? HELD_WHILE_CLEARING
                  : 'Nothing further happens on this invoice until it is released.'}
              </p>
              {survey.issueId ? (
                <Link
                  to="/issues"
                  className="inline-flex min-h-11 desk:min-h-9 items-center font-medium underline"
                >
                  The issue it opened
                </Link>
              ) : null}
            </div>
          ) : survey.held && survey.issueId ? (
            // Paid or written off: the hold stops nothing now, and the issue her answer opened is
            // still the one to put right.
            <div className="mt-2 text-sm">
              <p>{SURVEY_HOLD_REASON_LABELS.issue_reported}.</p>
              <Link
                to="/issues"
                className="inline-flex min-h-11 desk:min-h-9 items-center font-medium underline"
              >
                The issue it opened
              </Link>
            </div>
          ) : null}
          {owed && clearing && !survey.held ? (
            <p className="mt-2 text-sm text-navy/70">{HOLD_WHILE_CLEARING}</p>
          ) : null}
          <div className="mt-2">
            {!owed ? null : survey.held ? (
              <Button
                tone="quiet"
                disabled={busy}
                onClick={() => void run(() => releaseSurvey(invoiceId), 'Released.')}
              >
                Release
              </Button>
            ) : (
              <Button
                tone="quiet"
                disabled={busy}
                onClick={() =>
                  void run(
                    () => holdSurvey(invoiceId),
                    clearing
                      ? 'Held. The reminder, the call and the automatic charge wait until it is released. The bank payment on its way is not stopped by it.'
                      : 'Held. Nothing further happens on it until it is released.',
                  )
                }
              >
                Hold
              </Button>
            )}
          </div>
        </>
      ) : (
        <p className="mt-1 text-sm text-navy/70">
          Nobody has been asked on this invoice yet. Send the invoice and its words ask them.
        </p>
      )}

      {answers.length > 0 ? (
        <div className="mt-4 border-t border-navy/10 pt-3">
          <p className="mb-2 text-sm font-medium">What they said</p>
          <ul className="space-y-2">
            {answers.map((answer) => (
              <li key={answer.id} className="rounded-lg border border-navy/12 bg-cream p-3 text-sm">
                <p className="font-medium">
                  {FEEDBACK_FACE_LABELS[answer.face]}
                  {answer.area ? `: ${answer.area}` : ''}
                </p>
                {answer.line ? <p className="whitespace-pre-line">{answer.line}</p> : null}
                <p className="text-xs text-navy/65">{answerLine(answer)}</p>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      <form className="mt-4 border-t border-navy/10 pt-3" onSubmit={record} noValidate>
        <p className="mb-2 text-sm text-navy/70">
          {owed && clearing
            ? 'They told you on the phone? Record it here. An answer below happy, or one that names a part of the home that was missed, opens an issue and a follow-up, and holds the invoice. It does not stop the bank payment already on its way.'
            : owed
              ? 'They told you on the phone? Record it here. An answer below happy, or one that names a part of the home that was missed, opens an issue and a follow-up, and holds the invoice.'
              : 'They told you on the phone? Record it here. An answer below happy, or one that names a part of the home that was missed, opens an issue and a follow-up.'}
        </p>
        <SelectField
          id="answer-face"
          label="The face they gave"
          value={face}
          onChange={setFace}
          options={FEEDBACK_FACES}
          toLabel={(value) => FEEDBACK_FACE_LABELS[value]}
          placeholder="Choose the face"
        />
        <TextField
          id="answer-area"
          label="Which part of the home"
          value={area}
          onChange={setArea}
          autoComplete="off"
          hint="Only a part that was missed. Naming one opens an issue, whatever the face."
        />
        <TextAreaField
          id="answer-line"
          label="In their words"
          value={line}
          onChange={setLine}
          rows={2}
        />
        <Button type="submit" disabled={busy}>
          {busy ? 'Recording' : 'Record their answer'}
        </Button>
      </form>
    </section>
  );
}

/* ------------------------------------------------------------------ *
 * The automatic charge.
 * ------------------------------------------------------------------ */

/** Not yet claimed by a try: the office may still release it or say not to charge it. */
const CHARGE_UNPOSTED: ReadonlySet<string> = new Set(['waiting', 'held', 'due']);

/** A small count in words, the way the screen says it. */
const COUNT_WORDS = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];

/**
 * WHAT HER SAVED METHOD'S CHARGE DOES ONCE HER ZELLE REPORT IS CLEARED, by the rule the server answers
 * the clear by (the final review of 2026-10-17): chosen on a covering charge standing on the invoice,
 * not on her pause, since a report taken before the Stripe key was placed holds a charge with no pause
 * beside it. None where no charge of hers pays the invoice; paused while her pause stands; otherwise it
 * goes ahead as it would have.
 */
function chargeAfterClear(charge: InvoiceCharge | null, covers: boolean): ChargeAfterClear {
  if (charge === null || !covers || !CHARGE_UNPOSTED.has(charge.state)) return 'none';
  return pauseStands(charge) ? 'stays_paused' : 'goes_ahead';
}

/** Her pause for a Zelle stands: she pressed "I'm paying by Zelle", and the office has not lifted it. */
const pauseStands = (charge: InvoiceCharge) =>
  charge.pausedAt !== null && charge.pauseLiftedAt === null;

/** Where a charge stands while her pause for a Zelle holds it. */
const PAUSED_FOR_ZELLE = 'Paused: they are paying by Zelle';

/**
 * WHETHER A ZELLE IS ON RECORD FOR THE INVOICE, from the money the invoice itself lists (ops #54, item
 * 6): `only` when Zelle is the one way it was paid, `partly` when it is one of several, and null when
 * no Zelle is on record. Each way's own money, net of any handed back, so a Zelle refunded in full is
 * not one.
 */
type ZelleOnRecord = 'only' | 'partly' | null;

function zelleOnRecord(
  allocations: readonly { method: string; amountCents: number }[],
): ZelleOnRecord {
  const byWay = new Map<string, number>();
  for (const one of allocations) {
    byWay.set(one.method, (byWay.get(one.method) ?? 0) + one.amountCents);
  }
  const ways = [...byWay].filter(([, cents]) => cents > 0).map(([way]) => way);
  if (!ways.includes('zelle')) return null;
  return ways.length === 1 ? 'only' : 'partly';
}

/** How a charge the next run ended because nothing was owed was paid, when a Zelle is on record. */
function paidByZelleWords(zelle: ZelleOnRecord): string | null {
  if (zelle === 'only') return 'Paid by Zelle';
  if (zelle === 'partly') return 'Paid partly by Zelle';
  return null;
}

/**
 * WHAT THE NEXT RUN DECIDES, as the read says it (`nextRun`), while money is owed, Stripe is on and no
 * try has claimed the charge; null otherwise, when the panel reads the row as it stands. The row moves
 * only when a run writes it, so the panel said "Waiting for her answer" after she tapped happy, and after
 * she said she was paying by Zelle, until the next run inside business hours (the staging walk of
 * 2026-09-23).
 */
function upcoming(charge: InvoiceCharge, owed: boolean, stripeOn: boolean): ChargeNextRun | null {
  return owed && stripeOn && CHARGE_UNPOSTED.has(charge.state) ? charge.nextRun : null;
}

/**
 * Where it stands, in a few words: what the next run decides, or else the row as it stands. On an
 * invoice nothing is owed on, a charge no try has claimed is cancelled by the next run, which it says,
 * with the Zelle that paid it where one is on record, and never that it is paused (ops #54, item 6).
 */
function standsWords(
  charge: InvoiceCharge,
  next: ChargeNextRun | null,
  owed: boolean,
  zelle: ZelleOnRecord,
): string {
  if (!owed && CHARGE_UNPOSTED.has(charge.state)) {
    return zelle === null
      ? 'Nothing owed: cancelled on the next run'
      : 'Zelle recorded: cancelled on the next run';
  }
  if (next !== null) {
    switch (next.decision) {
      case 'charge':
        return INVOICE_CHARGE_STATE_LABELS.due;
      case 'hold':
        return next.reason === 'paying_by_zelle'
          ? PAUSED_FOR_ZELLE
          : INVOICE_CHARGE_STATE_LABELS.held;
      case 'cancel':
        return INVOICE_CHARGE_STATE_LABELS.cancelled;
      case 'wait':
        return next.why === 'paying_elsewhere'
          ? 'Waiting for a payment on its way'
          : INVOICE_CHARGE_STATE_LABELS.waiting;
      case 'give_up':
        return 'Cannot be charged';
    }
  }
  if (CHARGE_UNPOSTED.has(charge.state) && pauseStands(charge)) return PAUSED_FOR_ZELLE;
  return INVOICE_CHARGE_STATE_LABELS[charge.state];
}

/** A charge waiting for her word: on her good answer, or on the office's release of a later one. */
function waitingWords(charge: InvoiceCharge): string {
  // The first charge opens on her answer alone, so a release never opens it.
  if (charge.releasedAt !== null && !charge.firstCharge) {
    return 'Released, so it is charged on the next run inside business hours.';
  }
  return charge.firstCharge
    ? 'Charged once they say the clean went well, and never on silence. This is the first charge to their saved method, so it waits for their own answer, which the office can record above.'
    : 'Charged once they say the clean went well, or once the office releases it. Never on silence.';
}

/** What the next run does with the charge, in one sentence. */
function nextRunWords(charge: InvoiceCharge, next: ChargeNextRun): string {
  switch (next.decision) {
    case 'charge':
      return next.reason === 'answered_well'
        ? 'They said the clean went well, so it is charged on the next run inside business hours.'
        : 'Released, so it is charged on the next run inside business hours.';
    case 'hold':
      return CHARGE_HOLD_REASON_LABELS[next.reason];
    case 'cancel':
      return `${CHARGE_CANCEL_REASON_LABELS[next.reason]}, so the next run ends it without charging anything.`;
    case 'wait':
      return next.why === 'paying_elsewhere'
        ? 'A payment through Stripe is on its way for this invoice, or a Stripe page they could pay through is still open, so the charge waits until that has cleared or the page has expired. They are never charged twice.'
        : waitingWords(charge);
    case 'give_up':
      return 'Ops holds nothing it can charge their saved method through, so the next run ends the charge without charging anything, and a follow-up asks the office to send them the invoice.';
  }
}

/**
 * WHERE A CHARGE STANDS ON AN INVOICE NOTHING IS OWED ON, paid, written off or void (the walk of
 * 2026-09-23): what it came to, and never a door or a page that no longer applies. A charge no try has
 * claimed is ended by the next run, `paid_another_way` or `invoice_void`, and until then nothing about
 * it is the office's to press.
 */
function settledChargeWords(charge: InvoiceCharge, zelle: ZelleOnRecord): string {
  switch (charge.state) {
    case 'waiting':
    case 'held':
    case 'due':
      // Her Zelle, recorded, is the plain answer, where the office recorded one (ops #54, item 6).
      return zelle === null
        ? 'Nothing is owed on this invoice now, so the next run ends the charge without charging anything.'
        : 'Their Zelle is recorded, so nothing is owed on this invoice now, and the next run cancels the automatic charge without charging anything.';
    case 'charging':
      return 'Stripe has been asked. What it answers is recorded on this invoice.';
    case 'processing':
      return 'Their bank payment is on its way. It is recorded on this invoice once it clears.';
    case 'succeeded':
      return 'Paid, and recorded on this invoice.';
    case 'declined':
      return `Declined: ${charge.declineWords ?? 'the bank gave no reason'}. Nothing was charged.`;
    case 'needs_authentication':
      return 'Their bank wanted them to confirm the payment themselves. Nothing was charged.';
    case 'failed':
      return 'It did not go through, and nothing was charged by it.';
    case 'cancelled': {
      // Ended because nothing was owed, with a Zelle on record: that is how it was paid, said plainly.
      const byZelle = charge.cancelReason === 'paid_another_way' ? paidByZelleWords(zelle) : null;
      if (byZelle !== null) return `${byZelle}.`;
      return `${charge.cancelReason ? CHARGE_CANCEL_REASON_LABELS[charge.cancelReason] : 'Not charged'}.`;
    }
  }
}

/** Where the charge goes from here, in one sentence under what the panel lists. */
function chargeNextWords(
  charge: InvoiceCharge,
  stripeOn: boolean,
  owed: boolean,
  zelle: ZelleOnRecord,
): string {
  if (!owed) return settledChargeWords(charge, zelle);
  const unposted = CHARGE_UNPOSTED.has(charge.state);
  if (unposted && !stripeOn) {
    return 'Stripe is not switched on here, so nothing is charged automatically until it is.';
  }
  if (unposted && pauseStands(charge)) {
    const days = COUNT_WORDS[ZELLE_PAUSE_BUSINESS_DAYS] ?? String(ZELLE_PAUSE_BUSINESS_DAYS);
    return `They said they are paying this one by Zelle, so it is not charged while the pause stands. Record their Zelle when it comes, which ends the charge. If none is recorded in ${days} business days, a task asks the office to call them.`;
  }
  const next = upcoming(charge, owed, stripeOn);
  if (next !== null) return nextRunWords(charge, next);
  const everyWay = 'Send them the invoice: their page offers every way to pay.';
  switch (charge.state) {
    case 'waiting':
      return waitingWords(charge);
    case 'held':
      return charge.holdReason ? CHARGE_HOLD_REASON_LABELS[charge.holdReason] : 'Held.';
    case 'due':
      return 'Charged on the next run inside business hours.';
    case 'charging':
      return 'Stripe has been asked. The money is recorded on this invoice once Stripe says it arrived.';
    case 'processing':
      return 'Their bank payment is on its way, which takes a few business days. It is recorded on this invoice once it clears.';
    case 'succeeded':
      return 'Paid, and recorded on this invoice.';
    case 'declined':
      return `Declined: ${charge.declineWords ?? 'the bank gave no reason'}. Nothing was charged. ${everyWay}`;
    case 'needs_authentication':
      return 'Their bank wants them to confirm the payment themselves, which nobody can do for them. Send them the invoice: its card page asks their bank to confirm it there.';
    case 'failed':
      return `It did not go through, and nothing is recorded. The follow-up it raised says what happened. ${everyWay}`;
    case 'cancelled':
      return `${charge.cancelReason ? CHARGE_CANCEL_REASON_LABELS[charge.cancelReason] : 'Not charged'}. Their page offers every way to pay.`;
  }
}

/**
 * THE AUTOMATIC CHARGE (ops #46, step 4b), beside the question it waits on: where it stands and what
 * happens next, what Stripe was asked for and when, and the office's doors while no try has claimed
 * it. "Charge her saved card now" is offered only on a charge that is not the first under her saved
 * method, since the first waits for her own answer and the server refuses it, and never on one the
 * next run ends without charging (the review of 2026-09-23), and it asks once more before it
 * releases, because it moves money. "Do not charge this one" hands the invoice back to
 * every way to pay, and asks once more too, since it ends the charge for good (the staging walk of
 * 2026-09-23 found it acting in one press). The server's refusal, when it gives one, is shown as it
 * said it.
 *
 * WHERE IT STANDS IS WHAT THE NEXT RUN DECIDES (the same walk): the row moves only when the job's run
 * writes it, so the read carries the run's decision as the invoice stands (`nextRun`), and her good
 * answer, her pause or an issue opened shows the moment it is recorded.
 *
 * HER PAUSE FOR A ZELLE (the owner, 2026-09-23): when she pressed "I'm paying by Zelle" the panel says
 * who and when, that it is not charged while the pause stands, and when the office is asked to follow
 * up, and offers "Lift the pause" in place of the release, asked once more too, since it lets the
 * charge go ahead and her page no longer offers her Zelle; a held question or an open issue still
 * holds it after, and the question says so.
 *
 * WHILE HER REPORT STANDS that she has SENT it by Zelle (ops #71 item 5), "Lift the pause" is not
 * offered and a line says to clear her report first: lifting would charge her card beside a Zelle she
 * says is on its way, and the server refuses it `zelle_reported` whatever this shows. "Do not charge
 * this one" is still offered, since nothing then charges her card.
 */
function ChargePanel({
  invoiceId,
  charge,
  balanceCents,
  owed,
  stripeOn,
  zelle,
  zelleReported,
  onDone,
}: {
  invoiceId: string;
  charge: InvoiceCharge;
  balanceCents: number;
  /**
   * Money is still owed on the invoice. Once it is not, paid, written off or void, the office's doors
   * on the charge no longer apply and are not offered, and nothing sends her to a page to pay.
   */
  owed: boolean;
  /** Whether this deployment can charge at all, which needs a Stripe key here. */
  stripeOn: boolean;
  /** Whether a Zelle is on record for the invoice, from the money it lists (ops #54, item 6). */
  zelle: ZelleOnRecord;
  /** Her report through home that she sent it by Zelle stands, which withholds the lift (ops #71). */
  zelleReported: boolean;
  onDone: (sentence: string) => void;
}) {
  const [confirming, setConfirming] = useState<'release' | 'lift' | 'cancel' | null>(null);
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const noun = savedMethodNoun(charge.methodType);
  const unposted = owed && CHARGE_UNPOSTED.has(charge.state);
  const paused = pauseStands(charge);
  const next = upcoming(charge, owed, stripeOn);
  // While her pause stands the release would change nothing, so lifting the pause is offered instead;
  // nor on a charge the next run ends without charging, given up on or cancelled (the review of
  // 2026-09-23), where it would change nothing either and its question would say it charges.
  const endsUncharged =
    next !== null && (next.decision === 'give_up' || next.decision === 'cancel');
  const releasable =
    unposted && !paused && !endsUncharged && !charge.firstCharge && charge.releasedAt === null;
  // Not while her report that she sent it by Zelle stands: the office clears that first (ops #71).
  const liftable = unposted && paused && !zelleReported;
  const liftWaits = unposted && paused && zelleReported;
  // An issue open on the clean, a reply to read or the question held still stops a released charge;
  // a question that never reached her does not, because the office has checked with her. What the next
  // run decides says so the moment it is recorded, and the row once a run has written it.
  const stillStopped =
    next !== null
      ? next.decision === 'hold' && next.reason !== 'survey_not_delivered'
      : charge.state === 'held' && charge.holdReason !== 'survey_not_delivered';
  const amount = money(balanceCents);
  const releaseWords = stillStopped
    ? `This releases ${amount} to be charged to ${charge.methodLabel} without their tap, on the first run inside business hours after the hold is cleared.`
    : `This charges ${amount} to ${charge.methodLabel} on the next run inside business hours, without their tap.`;
  const liftWords = `This lets the automatic charge go ahead: ${amount} to ${charge.methodLabel} on the next run inside business hours once they have said the clean went well${charge.firstCharge ? '' : ', or once the office releases it'}. A held question or an issue open on the clean still holds it until a person clears it. Their page will no longer offer to pay it by Zelle. Lift it only once you have spoken with them.`;
  // It ends the charge for good, so it is asked once more, as the release and the lift are.
  const cancelWords = `This stops the automatic charge for this invoice: ${amount} is not charged to ${charge.methodLabel}, and it cannot be started again. Their page offers every way to pay instead, so send them the invoice.`;

  async function run(work: () => Promise<unknown>, sentence: string) {
    setBusy(true);
    setProblem(null);
    try {
      await work();
      setConfirming(null);
      onDone(sentence);
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section
      aria-label="The automatic charge"
      className="mb-4 rounded-xl border border-navy/12 bg-parchment p-4"
    >
      <h2 className="font-serif text-lg">The automatic charge</h2>
      {problem ? (
        <div className="mt-2">
          <ErrorNotice title="Not done" message={problem} />
        </div>
      ) : null}
      <dl className="mt-2">
        <Detail label="Charged to" value={charge.methodLabel} />
        <Detail label="Where it stands" value={standsWords(charge, next, owed, zelle)} />
        <Detail
          label="What opened it"
          value={
            charge.gateReason
              ? CHARGE_GATE_REASON_LABELS[charge.gateReason]
              : next?.decision === 'charge'
                ? CHARGE_GATE_REASON_LABELS[next.reason]
                : null
          }
        />
        <Detail
          label="Released"
          value={
            charge.releasedAt
              ? `${charge.releasedByName ?? 'The office'}, ${formatInstant(charge.releasedAt)}`
              : null
          }
        />
        <Detail
          label="Asked for"
          value={charge.amountCents === null ? null : money(charge.amountCents)}
        />
        <Detail label="Stripe answered" value={formatInstant(charge.chargedAt)} />
        <Detail label="Money arrived" value={formatInstant(charge.settledAt)} />
        <Detail label="Tries" value={charge.attempts > 1 ? String(charge.attempts) : null} />
        <Detail
          label="Paying by Zelle"
          value={
            charge.pausedAt
              ? `${charge.pausedByName ?? 'This person'} said so, ${formatInstant(charge.pausedAt)}`
              : null
          }
        />
        <Detail label="The office asked to follow up" value={formatInstant(charge.pauseChasedAt)} />
        <Detail
          label="Pause lifted"
          value={
            charge.pauseLiftedAt
              ? `${charge.pauseLiftedByName ?? 'The office'}, ${formatInstant(charge.pauseLiftedAt)}`
              : null
          }
        />
      </dl>
      <p className="mt-2 text-sm">{chargeNextWords(charge, stripeOn, owed, zelle)}</p>

      {unposted ? (
        confirming === 'release' ? (
          <div className="mt-3 rounded-lg border border-navy/15 bg-cream p-3 text-sm">
            <p className="mb-2">{releaseWords} Release it only once you have checked with them.</p>
            <div className="flex flex-wrap gap-2">
              <Button
                disabled={busy}
                onClick={() =>
                  void run(
                    () => releaseCharge(invoiceId),
                    'Released. It is charged on the next run inside business hours, unless something holds it.',
                  )
                }
              >
                {busy ? 'Releasing' : 'Yes, charge it'}
              </Button>
              <Button tone="quiet" disabled={busy} onClick={() => setConfirming(null)}>
                Not now
              </Button>
            </div>
          </div>
        ) : confirming === 'lift' ? (
          <div className="mt-3 rounded-lg border border-navy/15 bg-cream p-3 text-sm">
            <p className="mb-2">{liftWords}</p>
            <div className="flex flex-wrap gap-2">
              <Button
                disabled={busy}
                onClick={() =>
                  void run(
                    () => liftChargePause(invoiceId),
                    'Lifted. The charge goes ahead as it would have, and their page no longer offers Zelle in its place.',
                  )
                }
              >
                {busy ? 'Lifting' : 'Yes, lift it'}
              </Button>
              <Button tone="quiet" disabled={busy} onClick={() => setConfirming(null)}>
                Not now
              </Button>
            </div>
          </div>
        ) : confirming === 'cancel' ? (
          <div className="mt-3 rounded-lg border border-navy/15 bg-cream p-3 text-sm">
            <p className="mb-2">{cancelWords}</p>
            <div className="flex flex-wrap gap-2">
              <Button
                disabled={busy}
                onClick={() =>
                  void run(
                    () => cancelCharge(invoiceId),
                    'Not charged automatically. Their page offers every way to pay.',
                  )
                }
              >
                {busy ? 'Stopping' : 'Yes, do not charge it'}
              </Button>
              <Button tone="quiet" disabled={busy} onClick={() => setConfirming(null)}>
                Not now
              </Button>
            </div>
          </div>
        ) : (
          <>
            {liftWaits ? <p className="mt-3 text-sm">{ZELLE_REPORT_WORDS.liftWaits}</p> : null}
            <div className="mt-3 flex flex-wrap gap-2">
              {releasable ? (
                <Button disabled={busy} onClick={() => setConfirming('release')}>
                  {`Charge their saved ${noun} now`}
                </Button>
              ) : null}
              {liftable ? (
                <Button disabled={busy} onClick={() => setConfirming('lift')}>
                  Lift the pause
                </Button>
              ) : null}
              <Button tone="quiet" disabled={busy} onClick={() => setConfirming('cancel')}>
                Do not charge this one
              </Button>
            </div>
          </>
        )
      ) : null}
    </section>
  );
}

/* ------------------------------------------------------------------ *
 * Send her a link.
 * ------------------------------------------------------------------ */

/**
 * "SEND HER A LINK": a link of ours to this invoice for one person, made and shown once to copy, and the
 * links already made, each withdrawable. At home (concern B1d, D8) nothing is made: the panel shows her
 * invoice page at home for a person who holds a `client` door there and says why not for anyone else,
 * asking the server nothing; the links made before stay listed, and can still be withdrawn.
 */
function LinkPanel({
  invoiceId,
  clientId,
  grants,
  atHome,
  onChanged,
}: {
  invoiceId: string;
  clientId: string;
  grants: readonly GrantRow[];
  /** Her invoice page at home and the household's doors there, or null for the panel of today. */
  atHome: InvoiceAtHome | null;
  onChanged: (sentence: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [contacts, setContacts] = useState<readonly ContactRow[] | null>(null);
  const [contactsProblem, setContactsProblem] = useState<string | null>(null);
  const [contactId, setContactId] = useState('');
  const [made, setMade] = useState<GrantMade | null>(null);
  /** Her invoice page at home, shown for the person chosen (concern B1d). */
  const [shown, setShown] = useState<string | null>(null);
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open || contacts !== null) return;
    let live = true;
    setContactsProblem(null);
    getClient(clientId)
      .then((answer) => {
        if (live) setContacts(answer.contacts);
      })
      .catch((thrown: unknown) => {
        if (!live) return;
        setContactsProblem(
          thrown instanceof ApiError ? thrown.message : 'The household did not load.',
        );
      });
    return () => {
      live = false;
    };
  }, [open, contacts, clientId]);

  const nameOf = (id: string) => contacts?.find((contact) => contact.id === id)?.displayName;

  /** At home: her invoice page for the person chosen, or why not, and nothing asked of the server. */
  function showHerPage(home: InvoiceAtHome) {
    setProblem(null);
    setShown(null);
    const person = contacts?.find((contact) => contact.id === contactId);
    if (!contactId || !person) {
      setProblem('Choose who the link is for.');
      return;
    }
    const hers = herPageAtHome(home, person);
    if ('why' in hers) setProblem(hers.why);
    else setShown(hers.page);
  }

  async function make() {
    setProblem(null);
    if (!contactId) {
      setProblem('Choose who the link is for.');
      return;
    }
    setBusy(true);
    try {
      const answer = await createGrant({ targetKind: 'invoice', targetId: invoiceId, contactId });
      setMade(answer);
      onChanged('The link is made. Copy it into a text or an email to them.');
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'The link was not made.');
    } finally {
      setBusy(false);
    }
  }

  async function revoke(grantId: string) {
    setProblem(null);
    setBusy(true);
    try {
      await revokeGrant(grantId);
      if (made?.id === grantId) setMade(null);
      onChanged('Withdrawn. That link opens nothing now.');
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'The link was not withdrawn.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <details
      className="mb-4 rounded-xl border border-navy/12 bg-parchment p-4"
      onToggle={(event) => setOpen(event.currentTarget.open)}
    >
      <summary className="min-h-11 desk:min-h-9 cursor-pointer font-serif text-lg">
        Send them a link
      </summary>
      {atHome !== null ? (
        <p className="mt-2 text-sm text-navy/70">{AT_HOME_OFFICE_WORDS.panelIntro}</p>
      ) : (
        <p className="mt-2 text-sm text-navy/70">
          A link to this invoice for one person of the household, to copy into a message yourself.
          It opens their invoice and the ways to pay it for thirty days, and can be withdrawn here.
          Nobody signs in; there is no client login and never will be.
        </p>
      )}

      {problem ? (
        <div className="mt-3">
          <ErrorNotice title="Not done" message={problem} />
        </div>
      ) : null}

      {atHome !== null && shown !== null ? (
        <div className="mt-3 rounded-lg border border-gold/50 bg-gold/10 p-3">
          <p className="text-xs tracking-wide text-navy/55 uppercase">
            {AT_HOME_OFFICE_WORDS.shownLabel}
          </p>
          <p className="mt-1 font-mono text-sm break-all select-all">{shown}</p>
          <p className="mt-2 text-xs text-navy/70">{AT_HOME_OFFICE_WORDS.shownNote}</p>
        </div>
      ) : null}

      {made ? (
        <div className="mt-3 rounded-lg border border-gold/50 bg-gold/10 p-3">
          <p className="text-xs tracking-wide text-navy/55 uppercase">The link to send</p>
          <p className="mt-1 font-mono text-sm break-all select-all">
            {window.origin}
            {made.path}
          </p>
          <p className="mt-2 text-xs text-navy/70">
            Works until {formatInstant(made.expiresAt)}. It is shown here once; make another if it
            is lost.
          </p>
        </div>
      ) : null}

      {open ? (
        contactsProblem ? (
          <div className="mt-3">
            <ErrorNotice title="The household did not load" message={contactsProblem} />
          </div>
        ) : contacts === null ? (
          <Busy what="the household" />
        ) : contacts.length === 0 ? (
          <p className="mt-3 text-sm text-coral">
            Nobody is on file for this household, so there is nobody to send a link to.
          </p>
        ) : (
          <div className="mt-3">
            <SelectField
              id="grant-contact"
              label="Who it is for"
              required
              value={contactId}
              onChange={(id) => {
                setContactId(id);
                setShown(null);
              }}
              options={contacts.map((contact) => contact.id)}
              toLabel={(id) => nameOf(id) ?? id}
              placeholder="Choose the person"
            />
            {atHome !== null ? (
              <Button onClick={() => showHerPage(atHome)}>{AT_HOME_OFFICE_WORDS.show}</Button>
            ) : (
              <Button onClick={make} disabled={busy}>
                {busy ? 'Making' : 'Make the link'}
              </Button>
            )}
          </div>
        )
      ) : null}

      {grants.length > 0 ? (
        <div className="mt-4 border-t border-navy/10 pt-3">
          <p className="mb-2 text-sm font-medium">Links already made</p>
          <ul className="space-y-2">
            {grants.map((grant) => (
              <li key={grant.id} className="rounded-lg border border-navy/12 bg-cream p-3 text-sm">
                <p>
                  For {nameOf(grant.contactId) ?? 'a contact of the household'}.{' '}
                  {grant.openCount === 0
                    ? 'Never opened.'
                    : `Opened ${grant.openCount === 1 ? 'once' : `${grant.openCount} times`}, first ${formatInstant(grant.firstOpenedAt)}.`}
                </p>
                <p className="text-xs text-navy/65">
                  {grant.revokedAt
                    ? `Withdrawn ${formatInstant(grant.revokedAt)}.`
                    : `Works until ${formatInstant(grant.expiresAt)}.`}
                </p>
                {!grant.revokedAt ? (
                  <div className="mt-2">
                    <Button tone="quiet" onClick={() => revoke(grant.id)} disabled={busy}>
                      Revoke
                    </Button>
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </details>
  );
}

/* ------------------------------------------------------------------ *
 * Void it.
 * ------------------------------------------------------------------ */

function VoidButton({ invoiceId, onDone }: { invoiceId: string; onDone: (s: string) => void }) {
  const [confirming, setConfirming] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function run() {
    setBusy(true);
    setProblem(null);
    try {
      await voidInvoice(invoiceId);
      onDone('Void. It bills nothing and stays on the record.');
    } catch (thrown) {
      setProblem(thrown instanceof ApiError ? thrown.message : 'That was not recorded.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card className="mb-4">
      {problem ? (
        <div className="mb-3">
          <ErrorNotice title="Not voided" message={problem} />
        </div>
      ) : null}
      {confirming ? (
        <div>
          <p className="text-sm">
            Tap again to void this invoice. It stays on the record and bills nothing. A new one can
            be drafted from the visit.
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            <Button onClick={run} disabled={busy}>
              Yes, void it
            </Button>
            <Button tone="quiet" onClick={() => setConfirming(false)} disabled={busy}>
              Keep it
            </Button>
          </div>
        </div>
      ) : (
        <Button tone="quiet" onClick={() => setConfirming(true)}>
          Void this invoice
        </Button>
      )}
    </Card>
  );
}
